import Vuex from "vuex";

export default new Vuex.Store({
  state: {
    menu: [
      {
        path: "/about",
        name: "About",
        children: [
          {
            path: "/our-story",
            name: "Our success story",
          },
          {
            path: "/cant-find",
            name: "Cant’ find a vendor for your project",
          },
          {
            path: "/consider-outsourcing",
            name: "Can’t consider outsourcing",
          },
        ],
      },
      {
        path: "/portfolio",
        name: "Portfolio",
      },
      {
        path: "/blog",
        name: "Blog",
      },
      {
        path: "/contacts",
        name: "Contacts",
      },
      {
        path: "/available-developers",
        name: "Available Developers",
      },
    ],
    our_story_content: [
      {
        show: false,
        years: "2007",
        text: `
        <p>The company was founded in 2007 by <a href="https://www.linkedin.com/in/andrey-labunskiy-b6b00373/" target="_blank" class="outside_link">Andrey Labunskiy</a>, who started with another 2 guys that were also as dedicated as he was to supporting and developing their first client: <i>https://quotationjunction.com</i>. The MVP exceeded all expectations and the client continued to run their system development through us. While the client’s success grew, so did our dedicated team - while simultaneously sourcing new clients and promoting our services using a referral scheme.
        </p>
        `,
      },
      {
        show: false,
        years: "2008",
        text: `
        <p>
        By 2008 we had 15 developers and many new clients - all with their own unique challenges and learning curves. At that time we established a collaborative partnership with <i>trafficjunction.co.uk</i> and decided to move forward together.
        </p>
        <p>
        Since then, our client numbers; as well as their significance, have grown remarkably and we are therefore thankful for that specific partnership which helped us become who we are today. Please see a few examples below of some of the collaborations which we’ve been a part of since then:
        </p>
        <ul>
        <li><a href="https://pdaverticals.com/" target="_blank" class="outside_link">Pdaverticals.com</a> started working with us to develop their complicated <a href="/portfolio/project/pharmaceutical-system">pharmaceutical system</a>.
        </li>
        <li>
        <a href="/portfolio/project/parliament-today">Parliamenttoday.com</a> also hired us to support their site.
        </li>
        </ul>
        <p>
        Later in 2008, we invested into researching iOS and initiated a few pilot projects.
        </p>
        `,
      },
      {
        show: false,
        years: "2009",
        text: `
        <p>
        In early 2009, we were at that stage when Android first saw the light of day and the time to invest in learning about this new technology had dawned - so we jumped in headfirst.
        </p>
        <p>
        We developed a number of Android apps - the most memorable being <a href="/portfolio/project/ppc-editor">PPCEditor</a>, tthe app first used to manage Google AdWords campaigns from mobile phones. Google did not have any apps for their campaigns at that time.
        </p>
        <p>
        That app is still particularly memorable because before Google had started developing their own app, they had researched other popular apps on the market and had started a conversation with us about a possible partnership - at that time, we dared to dream that we would be partners with THE Giant, but unfortunately Google had decided to manage their own development instead of purchasing our app.
        </p>
        <p>
        Our fresh approach and experience in iOS/Android allowed us to cooperate closely with <i>Trafficjunction.co.uk</i> and we started working on the revolutionary project: <a href="/portfolio/project/touchpanel">touchpanelcontrol.com</a> which allowed us to use a mobile phone to control home automation systems by AMX.
        </p>
        <p>
        The tourist agency <a href="https://laspi.com/" target="_blank" class="outside_link">Laspi.com</a>, approached us to start working with them on <a id="laspi" href="/portfolio/project/laspi">their intranet</a> and we also gaineda significant (for us at the time) client who recruited us to work on their <a href="/portfolio/project/traffic-generation-system">Traffic Generation System</a>.
        </p>
        `,
      },
      {
        show: false,
        years: "2010-2013",
        text: `
        <p>
        Like attracts like.
        </p>
        <p>
        We had three new clients all working on similar ideas for  <a href="/portfolio/project/traffic-generation-system">traffic generation</a>. We established a dynamic team to work on similar systems development and support, and one of those clients stepped forward and implemented a fake traffic generation module into his system.
        </p>
        <p>
        In cooperation with TrafficJunction, we worked on a series of cross-platform <a id="games" href="/portfolio/project/games">mobile games</a> during this period, as well as with a few other clients who came onboard with gaming development too, and subsequently we developed a framework for educational games with its own series of gaming based on that particular <a href="https://flinklearning.com/apps?cat_id=1" target="_blank" class="outside_link">framework</a>. For another client, we even worked on a series of JS games, and many other memorable mobile apps were also developed during those first few years. Another really great client: <i>asapventures.co.uk</i> developed a framework for <a id="price-comparison-sites" href="/portfolio/project/price-comparison-sites">price comparison systems</a> and we managed over 20 apps for this system, as well as apps for various taxi/cab booking systems.
        </p>
        `,
      },
      {
        show: false,
        years: "2014-2017",
        text: `
        <p id="magento-journey">
        Finally, our <strong>Magento journey</strong> began in 2014.
        </p>
        <p>
        <a href="https://aheadworks.com/" target="_blank" class="outside_link">Aheadworks.com</a> is one of the original forerunners when it comes to the Magento extension development market, and their main specialized focus has always been on Magento extensions development. In their first 15 years of existence, <a href="https://aheadworks.com/" target="_blank" class="outside_link">Aheadworks</a> developed hundreds of Magento extensions and the majority of their focus was always placed on new extensions development, since many of their clients constantly requested new extension customizations.
        </p>
        <p>
        Hiring a Magento extensions vendor is always the most advantageous way of managing  <a href="https://aheadworks.com/" target="_blank" class="outside_link">Aheadworks</a>  customizations and through the years, many of their clients have realized this and requested customizations via them, and then - after getting excited about the quality of our work, turned into our permanent clients.
        </p>
        <p>
        In 2014 we agreed to enter into a partnership with <a href="https://aheadworks.com/" target="_blank" class="outside_link">Aheadworks</a> to assist with their extensions customizations. This required some time and investment to thoroughly investigate their extensions, but in approximately a year we had become adept in this field and set about building a dynamically strong team of Magento experts.
        </p>
        <p>
        In 2014 Andrey met <a href=" https://www.linkedin.com/in/romanglushchuk/" target="_blank" class="outside_link">Roman Glushchuk</a> who became a significant part of the company very quickly and who helped establish Wdev’s marketing strategy on an entirely new level.
        </p>
        <p>
        In 2017 we became an exclusive <a href="https://aheadworks.com/" target="_blank" class="outside_link">Aheadworks</a> partner in custom development and we will always be thankful to them for helping to place us on a level which attracted many new clients and helped us to establish such a strong Magento team.
        </p>
        <p>
        Moreover, <a href="https://aheadworks.com/" target="_blank" class="outside_link">Aheadworks</a> helped us to reach the next level of Magento development and with their assistance, we’ve learned how to deal with custom development requests related to 3rd party code and we’ve developed scripting for some of the most common; as well as complex, problems Magento sites usually experience. This collaboration was truly mutually advantageous and created a platform where all involved parties benefitted:
        </p>
        <ul>
        <li>
        More clients and profit to both parties
        </li>
        <li>
        Clients receive solutions at an affordable price (Pareto’s Law). Since we have so many solutions to tap into from our vast field of expertise, we don’t charge each client the full development price for an already existing solution - we just implement the already existent formula from our knowledgeable think-tank, at an affordable price.
        </li>
        </ul>
        <p>
        Besides working on Magento, we also managed to execute a few significant projects for some new clients:
        </p>
        <ul>
        <li>
         <a id="california-crane-school-certification-system" href="/portfolio/project/california-crane-school-certification-system">California Crane School Certification System</a>
        </li>
        <li>
        <a id="gameit" href="/portfolio/project/gameit">Gameit.us</a> - a unique gaming concept which created a platform where ‘prizes’ could be offered to users, which in turn created more advertising revenue than the actual product’s worth. This was developed as an iOS app.
        </li>
        <li>
        <a id="seo-reporter" href="/portfolio/project/seo-reporter">SEO-Reporter</a> - analytics software for the banking sector
        </li>
        <li>
        <a id="shout-outs" href="/portfolio/project/shout-outs">ShoutOuts</a> - a tool created to emulate and compete with Spotify, YoutubeMusic and iTunes, as well as many other exciting projects
        </li>
        </ul>
        `,
      },
      {
        show: false,
        years: "2018-2020",
        text: `
        <p>
        Thanks to <a href="https://g2i.com/" target="_blank" class="outside_link">G2i.com</a> we gained vast exposure while simultaneously helping them to better establish themselves. They brought a few significant clients to the table and we developed a series of exciting projects in collaboration with them:
        </p>
        <ul>
        <li>
         <a id="resolute-intranet-and-sundashboard" href="/portfolio/project/resolute-intranet-and-sundashboard">Resolute Intranet and ITA dashboard</a> -  a medical intranet
        </li>
        <li>
        <a id="sundashboard" href="/portfolio/project/resolute-intranet-and-sundashboard/#sundashboard">Sun Dashboard</a> - a neural network for medical data
        </li>
        <li>
        <a id="truebill" href="/portfolio/project/truebill">Truebill.com</a> - a tool to analyze various subscriptions
        </li>
        <li>
        As well as many other systems, including a series of React Native apps
        </li>
        </ul>
        <p>
        During these years we also managed to enlist a few well knowned clients:
        </p>
        <ul>
        <li>
         <a id="siemens-spc-anywhere" href="/portfolio/project/siemens-spc-anywhere">Siemens</a> - the experience we accumulated while collaborating with touchpanelcontrol.com helped us to develop an app to control Siemens home automation systems.
        </li>
        <li>
        <a id="citrix-startup" href="/portfolio/project/citrix-startup">Citrix</a> - we worked on their site to improve their online conferences.
        </li>
        </ul>
        <p>
        While many good things happened to us during this period of time, 2018 also had its fair share of problems. Our biggest Magento partner; <a href="https://aheadworks.com/" target="_blank" class="outside_link">Aheadworks</a>, was sold to a bigger IT company with a colossal body of development staff and they began to manage all their own custom development - leaving us with the significant challenge of rearranging our Magento team. Thankfully though, the losses brought victories and we established a successful collaboration with other key players on the Magento market.
        </p>
        <p>
        Unpredictable Magento development became one of our key focuses and to provide even better Magento services, we created a new company registered in Cyprus - Webdevs LTD.
        </p>
        <p>
        In 2018 the original company was split and is divided as follows:
        </p>
        <ul>
        <li>
        Wdevs INC US: is managed by <a href=" https://www.linkedin.com/in/romanglushchuk/" target="_blank" class="outside_link">Roman Glushchuk</a> and is focused on web, mobile, and desktop apps
        </li>
        <li>
        Webdevs LTD: is managed by <a href=" https://www.linkedin.com/in/andrey-labunskiy-b6b00373/" target="_blank" class="outside_link">Andrey Labunskiy</a> and is mainly focused on Magento development
        </li>
        </ul>
        <p>
        The companies are in partnership, but they are individually focused on different development areas.
        </p>
        `,
      },
      {
        show: false,
        years: "2020",
        text: `
          <h3>The Impact of COVID-19 and Our Growth</h3>
          <p>It’s hard to believe that COVID-19 deserves its own chapter in our story, but its impact on our company was undeniable.</p>
          <p>Before the pandemic, we had a beautiful, ever-expanding office in Kharkiv, Ukraine-our second home. Remote work wasn’t even a consideration for us back then. However, the global pandemic turned everything upside down, and as quarantine measures became mandatory, we were forced to adapt to remote working.</p>
          <p>The transition wasn’t easy. Our team wasn’t initially prepared for remote work, and we faced significant challenges. Management, administrative, and technical staff worked tirelessly to ensure our operations remained effective, even outside the office environment. It took months of training and adjustments to make remote work efficient.</p>
          <p>Though our office remained open to those who wanted to visit, only about 10% of our staff continued working there regularly.</p>
        `,
      },
      {
        years: "2021",
        text: `
          <h3>Preparing for an Unpredictable Future</h3>
          <p>As we embraced remote work, we expanded our hiring beyond Kharkiv. By 2021, we were onboarding talented individuals from across Ukraine, Europe, Russia, Belarus, and Asia.</p>
          <p>Hiring developers from Asia was particularly challenging. While there is immense talent in the region, language barriers and cultural differences made the process more demanding. On average, we interviewed 20 candidates to fill just one position.</p>
          <p>One of our most significant partnerships-established in 2009 with AMX (<a href="https://store.touchpanelcontrol.com/" target="_blank" class="outside_link">touchpanelcontrol.com</a>) and later expanded to their <a href="/portfolio/project/telemedicine-products-and-startups" target="_blank" class="outside_link">new company</a> acquired by a major US healthcare player-was thriving during this period. The rise of remote medicine spurred by the pandemic further solidified our collaboration.</p>
          <p>However, 2021 also brought challenges. We faced contract complications related to insurance and compliance. These issues led to a difficult decision: selling our Touchpanelcontrol.com team to the client.</p>
        `,
      },
      {
        show: false,
        years: "2022",
        text: `
          <h3>A Year of Resilience Amid Unimaginable Challenges</h3>
          <p>In February 2022, we finalized the deal to transfer our Touchpanelcontrol team-about 60 talented developers. While this decision wasn’t easy, it turned out to be timely.</p>
          <p><svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: -4px;"><path d="M36 0H0V12H36V0Z" fill="#245EAB"/><path d="M36 12H0V24H36V12Z" fill="#FDD400"/></svg> On February 24, 2022, the unthinkable happened: the war in Ukraine began. With 75% of our staff located in Ukraine and around 50% in Kharkiv, the immediate priority was ensuring everyone’s safety. Families fled, electricity was lost, and normal life came to a halt.</p>
          <p>Our clients stood by us, offering support and reassurance. Yet, we knew business continuity was essential. We began hiring urgently to replace developers who couldn’t work effectively due to the crisis. No one was fired, but many were temporarily replaced to maintain project momentum.</p>
          <p>Additionally, sanctions forced us to end collaborations with developers in Russia and Belarus. Within a few months, we replaced them with skilled professionals from Europe and Asia, thanks to our strong recruitment network.</p>
          <p>Ironically, our preparedness for remote work-thanks to COVID-19-proved invaluable. Without it, the business might not have survived, especially since one of our office buildings was hit by a Russian shell.</p>
        `,
      },
      {
        show: true,
        years: "2022 - 2024",
        text: `
          <h3>Adapting and Innovating: Expanding Our Horizons</h3>
          <p>Over time, our Ukraine-based team relocated to safer regions or moved abroad. However, many had already been replaced on their projects, leading to another challenge: how to provide them with meaningful work.</p>
          <p>Before the war, our sales efforts were focused on specific technologies aligned with available expertise. For example, if iOS developers were on the bench, the sales team sought iOS projects.</p>
          <p>In 2022, we took a different approach. We created secondary skills lists for our developers and broadened our sales focus to cover a wide range of technologies. This experiment, born out of necessity, turned into a breakthrough.</p>
          <p>We not only retained our developers but also experienced significant growth. By mid-2022, we ventured into areas we previously avoided, including:</p>
          <ul>
          <li><strong>WordPress/WooCommerce:</strong> 100+ clients</li>
          <li><strong>Shopify:</strong> 70+ projects</li>
          <li><strong>Drupal:</strong> 30+ projects</li>
          <li><strong>Python/Ruby on Rails:</strong> 15+ projects</li>
          <li><strong>Unity (VR/XR)</strong></li>
          <li><strong>AI/ML</strong></li>
          <li><strong>Blockchain</strong></li>
          </ul>
          <p><a href="/advanced-portfolio" target="_blank" class="outside_link">Explore our advanced portfolio to see more examples.</a></p>
          <p>This expansion even led us to a new hiring model: project-specific staffing. By tapping into our extensive recruitment network, we scaled rapidly and became capable of covering nearly any technology stack.</p>
          <p>If you’re curious about how we can help you achieve your goals, <a href="/contacts" target="_blank" class="outside_link">contact us today</a>.</p>
        `,
      },
    ],
    hitech_projects: [
      {
        id: "siemens-spc-anywhere",
        src: "siemens",
        title: "Siemens SPCanywhere",
        mode_dark:true,
        product:
          {
            id: "siemens",
            title: "Siemens SPCanywhere",
            desc: `<p>PhoneGap, HTML, CSS</p>`,
            head_image:'siemens',
            icons:['siemens_logo'],
            float_image:'phone-siemens',
            text: `
              <p>
                The Adobe PhoneGap Android based  application allows its users to access their Siemens SPC Intrusion system remotely. SPC is an innovative burglary alarm system which  allows users to make  their premises secure, e.g. their homes, offices or summer cottages. SPCanywhere enables users to view and control several sites. Using SPCanywhere users can set or unset their SPC Intrusion system, open doors, control outputs and check the status of their installations.
              </p>
              <p>
              With the help of IP cameras, users can even get  live images from selected sites.
              </p>
              <p>
              A graphical map view visualizes the installation and allows  the users to quickly see the status of their premises.
              </p>
              <p>All a user  needs to do to set up his home automation environment on his Android phone/tablet, is to specify the IP address of his Siemens SPCanywhere controller. The app will manage everything else. It’s pretty easy to install, set up and work with the app developed by us for Siemens.
              </p>
            `
          },
      },
      {
        id: "citrix-startup",
        src: "citrix",
        title: "Citrix Startup Accelerator",
        mode_dark:true,
        product:{
            id: "citrix-startup",
            title: "Citrix Startup Accelerator",
            desc: `<p>Adobe CQ 5 framework</p>`,
            head_image:'citrix',
            icons:['citrix_logo'],
            text: `
            <div class="row">
            <div class="column">
              <p>
               This site was built using Adobe CQ framework for Citrix.com as an informational portal developed to promote Citrix Labs; an investment program involved with enterprise startups who are in the process of creating the next generation of cloud infrastructure services, mobile enterprise solutions and collaboration technologies.
              </p>
              <p>
              The best feature of the site is that it is fully customizable, using the backend developed by us with  Adobe CQ.
              </p>
              <p class="without_margin_bottom"> Initially the client prefered WordPress to manage their site’s content.</p>
              </div>
              <div class="column">
              <p>
               We implemented WordPress customization as well,  however, Citrix’ policy was to move all internal projects to Adobe CQ platform , therefore we moved all CMS key moments from WordPress to Adobe CQ to accommodate them.
              </p>
              <p>Here is a link to their site <span class="red">https://citrixstartupaccelerator.com</span>.</p>
              <p>
              It looks like Citrix doesn't support citrixstartupaccelerator.com any longer, though Google keeps a lot of information about that great platform.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "telemedicine-products-and-startups",
        src: "telemedicine",
        title: "Telemedicine products and startups",
        mode_dark:false,
        head_image:'telemedecine',
        head_text_before_icon:"Unfortunately, we are not authorized to disclose the client's name publicly, however, it was a great Telemedicine startup that was purchased in 2018 by one of the bigger players in the Telemedicine arena and the products came to be the property of the buyer -  though it's worth  mentioning a few of the products that we developed for the client which helped it to become notable in the telemedicine industry and to be taken over by a more significant player.",
        colorBackground:'#1093bf',
        group_products: [
          {
            id: "psyc-wave",
            title: "PsycWave (AMX/Cisco)",
            desc: `<p>Java, Netlinx, IOS</p>`,
            icons:['amx_logo','cisco_logo'],
            text: `
              <p>
              A joint project for iOS by two prominent IT corporations: AMX and Cisco. PsycWave is a revolutionary project which converts a standard classroom into a distance learning classroom by providing intuitive content control and an enterprise-quality TelePresence connection between classrooms. The hardware partly consists of AMX NI 3100 processor and Cisco C90 codec. The app includes:
              </p>
              <ul>
                <li>
                the ability to control all video conferencing hardware in the room;
                </li>
                <li>drag-and-drop support;</li>
                <li>
                support for up to four HD displays and five HD sources;
                </li>
                <li>
                ability to run the application on multiple devices in the same room;</li>
                <li>setup and maintenance wizard.</li>
              </ul>
              <p>
              Finally, the device was rebranded into Educator and presented at the InfoComm 2013 conference in Orlando, Fl.
              </p>
            `,
            product_image:['psycwave']
          },
          {
            id: "video-cloud",
            title: "Video Cloud",
            desc: `<p>Node.js, IOS, Android, Tokbox, Vidyo, SIP</p>`,
            text: `
              <p>
              Initially, the system was aimed at setting up an easy connection between patients and doctors’ colleges to define a diagnosis quickly and effortlessly, as well as to discuss all the details of future medical treatments, and it’s also worth mentioning that during the development stage, the client defined even more areas of the system’s usage.
              </p>
              <p>
              The system allows you to set up a High-Quality video conference in minutes from anywhere, from any device and any compatible software (Cisco Jabber, Polycom RealPresence, or Microsoft Lync). An iOS/Android app doesn’t require any complicated configuration and therefore the user needs only to accept an invitation to join a video conference, or specify their email address to allow the server software to set up everything on their behalf.  This system features the following:
              </p>
              <ul class="without_margin_bottom">
                <li>
                full history of video calls;
                </li>
                <li>
                  access to recorded conferences stored in the cloud;
                </li>
                <li>
                  Far End Camera Control (FECC): one can remotely control the camera pan and zoom;
                </li>
                <li>
                Screen Sharing: with just one  click,  broadcast presentations, documents, etc. can be shared;
                </li>
                <li>
                A scalable system that allows you to manage subscriptions easily when scaling accounts up or down;
                </li>
                <li>
                Safety & Security: HIPAA compliant privacy, security features and server redundancy keep users safe while minimizing downtime.
                </li>
              </ul>
            `,
            product_image:['videocloud']
          },
          {
            id: "virtual-reception",
            title: "Virtual reception",
            desc: `<p>Objective C, SQLite, Rest, WebRTC, TokBox, Vidyo</p>`,
            text: `
              <p>
                This app is a virtual hospital reception service  The user is able to connect to a virtual doctors’ network for online consultations.
              </p>
              <p>
                Initially, the user describes his symptoms, and the virtual reception researches the symptoms and has an option to request additional information from the user. Once the initial inquiry is made, the receptionist refers the inquiry to the most appropriate doctors. The patient receives the doctors’ available time slots, and then he may pick an appointment that is suitable for him.
              </p>
              <p>
                Once the appointment is set, the user gets the app's invite to join the highly secured video conference with the doctor.
              </p>
              <p>
                The doctor answers the patient's questions during the highly secured video conference and sets a medical diagnosis which is followed by a prescription, if necessary.
              </p>
              <p>
                There is a wide network of pharmacies that are registered with the program. The user can pick a pharmacy located within the radius set in the app, or order online for delivery.</p>
              <p>
               All the prescription information is stored in the app, and  the user may request any clarification from the doctor in an in-app chat.
              </p>
              <p>
               The doctor can schedule the next appointment for the patient after the medical inquiry/examination.
              </p>
              <p>
                All virtual visits/consultations, prescriptions and therapy results are stored securely in the app.
              </p>
              <p>The app is completely HIPPA compliant.</p>
            `
          },
        ],
      },
      {
        id: "resolute-intranet-and-sundashboard",
        src: "resolute",
        title: "A few medical HIPAA compliant intranets examples",
        mode_dark:false,
        head_image:'resolute',
        colorBackground:'#f2f2f2',
        group_products: [
          {
            id: "resolute",
            title: "Resolute Intranet / ITA dashboard",
            desc: `<p>Node.JS, Expressjs, Bookshelfjs, Bluebird, Socket.io + Primus, Mochajs, Redis, Siege, Rabbitmq, Chaijs, Gulp, Hippie, Knexjs, Lodash, Vagrant, Docker, Postgree SQL, Mongo DB</p>`,
            icons:['advisors'],
            icons_bottom:['angular','mandrill','twilio'],
            text: `
              <p>
              Our customer theitadvisors.com has various clients that he works with. Among  them there is a medical corporation which includes many different companies all over the world, selling various medical products.
              </p>
              <p>
              There are numerous consultants and members who rely on constant and timely communication, as well as being updated on everything that happens within the company. Theitadvisors.com asked us to set up a system that would allow tracking everything in real time, including:
              </p>
              <ul>
                <li>
                   Login using Microsoft Active Directory Fideration Services;
                </li>
                <li>
                  Access to corporate email using SSO Authorization;
                </li>
                <li>
                  Calendar events syncing via MS Exchange;
                </li>
                <li>
                  Global SMS warnings via <a href="https://twillo.com" target="_blank">https://twillo.com</a>;
                </li>
                <li>
                  Forum infrastructure based on <a href="https://mutt.com" target="_blank">https://mutt.com</a>;
                </li>
                <li>
                  Real time notification via <a href="https://pubnup.com" target="_blank">https://pubnup.com</a>;
                </li>
                <li>
                  Mass mailing via <a href="https://mandril.com" target="_blank">https://mandril.com</a>;
                </li>
                <li>
                  Issues tracking based on <a href="https://bugherd.com" target="_blank">https://bugherd.com</a>;
                </li>
                <li>
                  Various informational features as FAQs, Links, News, Events, Files storage etc.;
                </li>
                <li>
                  Smart search for everything stored in the system using <a href="https://sphinxsearch.com" target="_blank">https://sphinxsearch.com</a>.
                </li>
              </ul>
              <p>
              The dashboard was built using Angular.JS which allows it to precache interfaces, as well as do online system work in the same way that a  common desktop application works, despite the system being full of fancy animation designed to make the final users fall in love with working the system.
              </p>
              <p>
              The client enjoyed  the system so much that Theitadvisors.com decided  to expand their system and make it scalable, as well as  easily customizable and to be  able to adapt the dashboard for the needs of their every client, as well as for their own staff using it.
              </p>
              <p>
              The next generation of dashboard has been recoded to Node.js - this was by the client’s request. Beside the features listed above, the dashboard also has following features:
              <ul>
                <li>
                Google domain for business authorisation;
                </li>
                <li>
                Documents storage  in Google Drive using GDrive API;
                </li>
                <li>
                  Many various Angular based forms with 300+ different fields;
                </li>
                <li>
                  Versioning system for data;
                </li>
                <li>
                Self made WiKi with tracking of all changes.
                </li>
              </ul>
              </p>
            `,
            product_image:['resolute1']
          },
          {
            id: "sundashboard",
            title: "Sun Dashboard",
            desc: `<p>Node.js, pm2 - server side;<br/>
             React, D3, Sigma.Js, Redux, Bootstrap - client side;<br/> MSSQL</p>`,
            icons:['react','redux'],
            text: `
              <p>
              This is a dashboard aimed at displaying a graphic presentation of the statistical information. The problem is that  personal data of all the Prescribers, Patients and Pharmacies are stored on the remote MSSQL server and we are not able to maintain permanent connection to the server, since all data there is HIPAA compliant.
              </p>
              <p>
              To display data on the dashboard, we therefore have to pre-calculate all data on the secured server and then we need to send JSON files with re-calculated information to be displayed on the dashboard server. The pre-calculated information is actually an analytical prediction of the future users’ performance, based on previous performance changes, which were originally  based on Trends and PSI factors.
              </p>
              <p>
              JSON may have up to 200.000 records with up to 10 fields in each , therefore we use streaming data while downloading to manage a synchronous calculation from all the obtained data while the whole package of data has not been received.
              </p>
              <p>
              The dashboard allows admins to manage various filtering/sorting options from among the received data.
              </p>
              <ul class="without_margin_bottom">
                <li>
                React.js and Redux were used to develop the dashboard.
                </li>
                <li>
                Saga Redux was used for async working with data streams.
                </li>
                <li>
                Redux Route was used for keeping route in a stage.
                </li>
                <li>
                A barely customised D3.js was used for displaying graphics.
                </li>
                <li>
                Saga.js was used for neural network calculation and visual displaying of the links in the network.
                </li>
              </ul>
            `,
            product_image:['sundashboard']
          },
        ],
      },
      {
        id: "laspi",
        src: "al-based",
        title: "Intranet with AI-based site visitors behavior prediction",
        mode_dark:false,
        head_image:'laspi',
        colorBackground:'#F8F774',
        group_products: [
          {
            id: "intranet-laspi",
            title: `Intranet for laspi.com `,
            product_image:['laspi1'],
            text: `
              <p>
                <a href="https://laspi.com/" target="_blank">Laspi.com </a>  is one of the biggest tourist agencies in Crimea. Their business model is quite complicated, as they rent out many hotels (completely or partially, e.g. an entire floor) and resorts in Crimea, as well as  selling their tours all over the world. Laspi has quite a few branches and partners, and their accounts settlement rules are quite sophisticated:
              </p>
              <ul>
                <li>
                Tourist may use various currencies when paying in cash, as well as using wire transfers
                </li>
                <li>
                Crimean hotels have various accommodation tariffs based on the number of tourists per room (extra bed for an adult/child also affects the price calculation formula)
                </li>
                <li>
                The accommodation prices are seasonal (e.g. there are several peak season periods during  summer)
                </li>
                <li>
                Extra services such as transfer, SPA, massages, etc.  are also available for purchase.
                </li>
              </ul>
              <p>
              Since both Laspi and their partners all have different components involved in their  accomodation price calculation formula, the system allows them to manage their accounts settlement pretty easily.
              </p>
              <p>
              To become a professional tourist agency manager and get to know all the details of that business, one needs many years of work and training, therefore the system is also aimed at eliminating the human factor and reducing its impact on the business. The system enabled Laspi to use inexpensive tour operators’ services to sell their tours.  These days Laspi managers are able to get to know the system within a week and begin selling  tours immediately. The system suggests an appropriate hotel/room based  on the tourist’s needs and expectations, and does  all the calculations automatically. The tour operator doesn’t need to know the number of hotel rooms available, since the system provides a hotel load graph and the only thing you have to do to locate a tourist is to drag-and-drop them over the graph. So, the human error factor is reduced to almost zero.
              </p>
              <p>
              We spent a month on a business trip communicating with this client, in the interest of  understanding their business model and to suggest an appropriate solution which would meet their budget requirements.
              </p>
            `,
          },
          {
            id: "behaviour-laspi",
            title: `Users' behaviour prediction laspi.com`,
            text: `
              <p>
              Laspi directors were happy with the system we had developed,  and since they have many site visitors and invest wisely in many successful advertising campaigns, they asked us to consider ads expenses optimization and helping them achieve  maximum profit. Having analyzed their traffic, we offered them a way to make a keyframes graph of their site visitors’ behaviour, as well as using a hierarchical clustering algorithm to turn those graphs into a self-learning neural network. Then once the neural network was ready, we were able to predict the users’ behaviour and use a short path problem solving algorithm to show relevant content to the user.
              </p>
              <p>
              Now the Laspi website is able to predict users’ behaviour and set user roles once a  user has spent some time browsing the site. For example, there are roles such as Regular Visitor, Potential Tour Buyer, Potential Partner, Advertising Agency, etc.  Therefore, if we deal with a tour buyer, the system defines whether they are interested in a particular hotel and shows the relevant information to the tourist. If the system defines a potential partner, it notifies Laspi managers and the site offers the visitor the chance to  chat with one of the Laspi managers. The more users visit the Laspi website, the more roles set by the managers are  confirmed, and the more accurate users’ behaviour predictions they receive .
              </p>
            `,
          },
        ],
      },
      {
        id: "hygh",
        src: "hygh",
        title: "Innovative advertising system to manage billboards online",
        mode_dark:true,
        product: {
            id: "hygh",
            title: "HYGH tech",
            head_image:'hygh',
            text: `
            <div class="row">
            <div class="column">
            <p><a href="https://hygh.tech" target="_blank">HYGH</a> is an ambitious German startup that is aimed to make a revolution in billboards advertising. I was a part of the team that worked on MVP for HYGH. The idea of the project is pretty simple. The client can define areas of the advertising space ( Usually it's an Android box connected to a TV or a huge TFT panel) and to establish a behavior of each area, that could be a running text, video, or a picture or a sequence of them. The user-friendly interface allows to turn complicated advertising materials editing/formatting into fun.
            </p>
            </div>
            <div class="column">
            <p>
            A predefined advertising program may be used in both offline and online mode. Offline mode is a precompiled app that the user uploads to an Android stick.
            </p>
            <p>
            It is worth mentioning that currently HYGH is the platform based on GoLang. However, initially we implemented the idea of the startup using Laravel, Vue.js and Angular. Hygh.tech has the best marketing team. They promoted the MVP perfectly and got enough investment. After that, they considered purchasing another German startup that already had the platform for streaming video on billboards. However the investments were received with help of MVP that our team developed for them.
           </p>
           </div>
           </div>
            `,
          },
      },
      {
        id: "seo-reporter",
        src: "seo-reporter",
        mode_dark:true,
        title:
          "Analyzer for the leaders of analyzing (Google, Sistrix, Advancedwebranking, Onpage etc)",
        product:
          {
            id: "seo-reporter",
            title:
            "SEO-Reporter",
            desc: `<p> Backend: React.js. PhatomJS, PostgreSQL<br/>
            Frontend: Node.js, Express, NSQD</p>
            `,
            head_image:'seo-reporter',
            text: `
            <div class="row">
            <div class="column">
              <p>
              This project is an extremely powerful analyzing tool which  combines experience  with the data gained from promotion systems, such as Google Search Console (GSC), Onpage, Sistrix and AWR (Advancedwebranking), etc. Our system combines their data and calculates a median which is even more accurate than other systems. Once we worked with a client specializing in banking, and when their bank was in the process of launching a large marketing campaign, they added different analyzing tools to their websites. Having analyzed their  data, we viewed  the data from various analytics tools to find a  different perspective. For example, the data from Google Search Console (GSC)  was different to the data from Sistrix , therefore our system calculates a median and provides an extremely accurate value indicator, …and we were  pleasantly surprised to not  have found such an option at Google before we had created it.
              </p>
              <p class="without_margin_bottom">
              The thing is, Google shows data for the most recent 90 days only, while our SEO-reporter allows you to receive  and filter data for an indeterminable time period instead. Moreover, we added some extra widgets with which  the client is able to assign the data type for both X and Y axes and build a custom graph, as well as being able to select any of the default widgets.
              </p>
              </div>
              <div class="column">
              <p>The fact that the system is  able to save the settings, makes it extremely user-friendly ,  and furthermore, there is a small cheat option hidden, which has the  ability to adjust data on the graph and constantly maintain your reports.</p>
              <p>
              In addition, we extended the amount of data by merging different promotion systems. For example, Google allows authorized users to define their language, age, gender, employment and income, as well as  other options, while unauthorized users may only define their location. However, a user might be logged into another system, e.g. there are more  people using MSN instead of Google for their everyday need ,  so for those users, we collect the data from MSN analytics and combine them with the data  received from  Google users. Such an approach allows us to obtain  more data and apply various filters, e.g. to find out sales correlations which are based on season and gender/age criteria.
              </p>
              <p>
              In other words, we took the data from  famous tools and used their experience to improve data representation, as well as putting in vast amounts of  effort to combine the data filtering in from various sources into a far more powerful tool!
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "seeking-simple",
        src: "search-engine",
        title: "Search engine to match lifestyle and dietary needs ",
        mode_dark:true,
        product:
          {
            id: "seeking-simple",
            title: "Seeking simple",
            desc: `<p>Backend: PHP 7.2.2, Laravel 5.6, MongoDB 3.6<br/>
            Frontend: VueJs 2, Bootstrap 4</p>`,
            head_image:'seekingsimple2',
            text: `
            <div class="row">
            <div class="column">
              <p>
              This is a search engine which enables you to find products that match your lifestyle and dietary needs.
              </p>
              <p>
              It allows consumers, or professional nutritionists to create personal accounts and dietary sets that they  may use to find and select products matching certain requirements.
              </p>
              <p>
              Consumers get  detailed information about products they are interested in and this helps them make an informed decision  when choosing the right product for their needs.
              </p>
              <p>
              Each consumer is able to create a Dietary Set that meets their nutritional requirements in a quick and simple process. This Dietary Set is used as a 'filter' while choosing products, i.e. one can add, delete or rank-order the products that meet their dietary requirements.
              </p>
              <p>
              ither a brand company or their authorized agents can load, update and manage information regarding their products, as well as keeping their clients updated of special offers with barely any effort.
              </p>
              </div>
              <div class="column">
              <p>
              The system investigates the clients’ preferences and tries to offer them the exact products they are looking for. For example, a customer is typing “Tomato”, and there are many products with this word in the title (it can be tomato pasta, ketchup, powder, etc). However, if the user already has a set of selected products, so that the system defines that he is mostly interested in a tomato vegetable, then the first product suggested will be a vegetable.
              </p>
              <p>
              Moreover, the system always suggests products using an effective algorithm for related products. The more products the user selects, the more relevant suggestions the system will be providing.
              </p>
              <p>Integrated services:</p>
              <ul class="without_margin_bottom">
                <li>Facebook oAuth</li>
                <li>Pinterest</li>
                <li>Google maps</li>
              </ul>
              </div>
              </div>
            `,
          },

      },
      {
        id: "razzo",
        src: "razzo",
        mode_dark:true,
        title: "Razzo is analytics tool for Magento to scale up the business",
        product:
          {
            id: "razzo",
            head_image: "razzo",
            title: "Razzo",
            desc: `<p>Backend: The project architecture is built on Laravel, using the MySQL data management system<br/>
            Frontend: Tailwind CSS, Vue.js, charts embedded using ApexCharts.js</p>`,
            text: `
            <div class="row">
            <div class="column">
            <p>Razzo is an effective tool for collecting statistics for Magento sites. Thanks to easy-to-use infographics and in-depth information, the owner of an eCommerce store on Magento can get a complete analysis of the sales of his products, draw up a portrait of the client and analyze his behavior. For example, you are running an advertising campaign to increase sales on your site; this tool allows you to track all key indicators in detail, and displays them in simple and illustrative graphs.
            </p>
            <p>
            For the continuous operation of widgets and data import, a Laravel-based data collection system has been created, built on server request queues.
            </p>
            <p class="whitout_margin_bottom">
            Our team had faced the problem of huge amount of data that needed to be processed.
           </p>
           </div>
           <div class="column">
           <p>That implied a high load on the Magento servers, which, in turn, could lead to such requests being blocked. To solve this problem, we created a system of parallel chains of query workers, which takes into account the current load on the server and adjusts the sending of queries to it.</p>
           <p>
           One of the unique features of this project is a feature that allows to select relevant products for each item based on the most purchased of them. Since Magento's standard tools do not offer this option, Razzo gives the opportunity to the customer to import information on their site using the Magento API and display relevant products to customers.
           </p>
           <p>
           <strong>Future plans:</strong> Synchronization with Google tools and other popular CMS platforms.
           </p>
           </div>
           </div>
            `,
          },

      },
      {
        id: "hopways",
        src: "hopways",
        title: "Simplifying School Commutes For Kids & Parents With hopways.com",
        colorBackground: '#E8C550',
        mode_dark:true,
        product:
          {
            id: "hopways",
            head_image: "hopways",
            title: "Hopways",
            text: `
                <p>Hopways was developed to make school commutes easier for kids and their parents through a subscription service. The project caters to parents, especially those with a bit more disposable income, who want a reliable way to get their children to school regularly or on specific days.</p>
                <p>To provide top-notch service, Hopways carefully selects drivers with solid experience. Each driver goes through an extensive application process, filling out a detailed form and submitting the necessary documents (find the form <a href="https://www.hopways.com/drivers/" target="_blank">here</a>). After that, they have an interview and a thorough check to ensure they meet all the requirements.</p>
            `,
        },
        products: [
          {
            id: "promo-website",
            title: "Promo website",
            text: `
              <p>For this project, we completely rethought the look and feel of the previous site, creating a simpler and more user-friendly experience tailored to our target users, parents, and drivers. We wanted to make sure that all the essential information was easy to find, helping visitors understand the service quickly and feel confident about choosing it. By reorganizing the site’s structure and placing call-to-action buttons in just the right spots, we made it easier for users to navigate and take action, which led to a noticeable increase in conversions.</p>
              <p>We also added contact details to make reaching the Hopways team straightforward and accessible. We’ve made it easier than ever to reach out – our team added a prominently displayed phone number and email in the header for quick, hassle-free communication. Plus, the footer got an upgrade too, now neatly packed with essential details like contact info, social media links, and working hours.</p>
              <p>In fact, the whole page layout has had a thoughtful refresh. Now, users can effortlessly navigate to any page, get in touch with support in a single click, and find all the key details about the system right where they need them.</p>
              <p>Although the site looks simple on the surface, a lot of time and effort went into understanding what users need most. Our analysts and marketers dug deep to shape each element in a way that improves the experience without overcomplicating it. The result is a clean, effective site that makes an impact by being easy to use and helping more people connect with the service.</p>
            `,
          },
          {
            id: "portals",
            title: "Portals",
            text: `
              <p>Our team developed user-friendly portals for both parents and drivers using Laravel, Vue 3, and Inertia.js, creating a seamless experience tailored to each group. The project is hosted on AWS, and we manage email communications through Microsoft Graph API. To ensure smooth operations, we integrated with key services like Way-Plan, Pennylane, and Hubspot.</p>
            `,
          },
          {
            id: "parents-portal",
            title: "Parent’s portal",
            text: `
              <p>For parents, the portal provides a clear weekly schedule with pick-up and drop-off times, addresses, and driver information, all viewable at a glance. They can export this schedule as a PDF, review past trips, cancel rides if needed, and see invoices right in the portal. Parents also benefit from a real-time map feature to track their child’s ride. If assistance is needed, they can submit support tickets via Hubspot for prompt replies. They can also request additional rides outside of their subscription, adding flexibility to their service.</p>
            `
          },
          {
            id: "drivers-portal",
            title: "Driver’s portal",
            text: `
              <p>Drivers have their own portal, where they can check their schedules with pick-up and drop-off details and parent contact info. They’re able to opt out of trips, request additional fees for tolls or expenses, and monitor their payments. Both parents and drivers have personal profiles - parents can include important details about their child, like any special needs, while drivers upload their license, vehicle details, and photos.</p>
            `,
          },
          {
            id: "project-launched",
            title: "Project launched",
            text: `
              <p>The project kicked off in February 2024 with an initial consultation where we spent time understanding the client’s vision, analyzing requirements, and setting clear goals. Our team then got to work designing a step-by-step plan that would allow us to build each part of the system on a tight timeline without sacrificing quality. We used agile practices to keep the development process flexible, allowing us to adapt quickly to any new insights that came up along the way. Each stage focused on delivering a smooth user experience and strong functionality, both of which we knew would be essential for Hopways’ success.</p>
              <p>By August 2024, after several rounds of testing and refinement, we launched the full system for live users. The initial feedback from both Hopways and their user base was very encouraging - users found the platform easy to navigate, reliable, and useful in meeting their needs. The client was pleased with the system’s stability and scalability, and this early success also inspired some fresh ideas for new features and improvements.</p>
            `,
          },
          {
            id: "project-support",
            title: "Project support",
            text: `
              <p>Since the launch, our team has continued working closely with Hopways to support the platform’s growth. We are actively building out new features based on user suggestions and client feedback, and we handle all technical requests to keep the system running smoothly. This ongoing collaboration ensures that the platform stays up-to-date and aligned with Hopways’ evolving needs, giving them a solid foundation to expand their services and continue delivering value to their users.</p>
            `,
          },
        ],
      },
    ],
    mob_projects: [
      {
        id: "amx-modules",
        src: "amx",
        title:
          "Not trivial mobile, but still mobile modules - a great example to indicate a phase in a very exciting part of our non trivial  journey",
        mode_dark:true,
        product:
          {
            id: "amx-modules",
            title: "AMX modules",
            desc: `<p>NetLinks, Java Cafe Duet, TP4</p>`,
            head_image:'amxmodules',
            icons:['amx_logo'],
            text: `
            <div class="row">
            <div class="column">
            <p>Within <a href="https://store.touchpanelcontrol.com/" target="_blank">TouchPanelControl</a> we developed a few exciting modules for AMX controllers. The technologies used for module’s composing are Java Café Duet and native AMX development language (NetLinx), which  provides the ultimate compatibility with old AMX controllers.</p>
            <p>
                <strong>XBMC Control</strong> module allows  its users to easily manage local and cloud-based media with a wide range of features and content for AMX control interface: track listing, cover art and playlist creation.
              </p>
              <p class="without_margin_bottom">
                <strong>Apple Media Control</strong> module provides  its users  with an entirely new musical experience to enjoy while  listening to their shared and online Apple iTunes content. The module has features like track listing, cover art, playlists, library browsing, etc.
              </p>
            </div>
            <div class="column">
            <p>The Apple Media module provides unprecedented control that takes the pleasure of listening to music to an entirely new level.</p>
            <p>
            <strong>Sonos control</strong> module introduced  the Sonos experience to the touch panel interface. With the built-in ability of controlling individual Sonos Zones and the power to enable grouping and ungrouping, the Sonos Module displays all the user’s favorite music, as well as Radio and Line-in selection items. The module allows browsing the music and selecting which zone to control, changing the volume of group several areas together, all with the convenience of touch panel control.
          </p>
            </div>
            </div>
          `
          },
      },
      {
        id: "shout-outs",
        src: "apple",
        mode_dark:true,
        title: "The app that pretended to compete with  Apple Music",
        product:
          {
            id: "shout-outs",
            title: "ShoutOuts",
            desc: `<p>iOS SDK, Facebook SDK, Mongo DB,SQLite, Postgree SQL Echoprint</p>`,
            head_image:'shoutouts',
            text: `
            <div class="row">
            <div class="column">
              <p>
              This Facebook-based social network ; which uses a FB database , allows music sharing amongst its members. The mobile application uses the iPhone’s microphone to record a piece of music being played, then it identifies an acoustic fingerprint created on the sample and searches  through the central fingerprint database for a match. The song’s information is displayed to the user if a  match is found.
              </p>
              <p class="without_margin_bottom">
               We used <a href="https://echoprint.me/" target="_blank">EchoPrint</a>’s identification server to find  the fingerprints, since their DB uses <a href="https://musicbrainz.org/" target="_blank">the largest music encyclopedia database</a>.
              </p>
              </div>
            <div class="column">
              <p> There is a collection of more than 500,000 songs, and users can operate with the shared music in much the same way that they do  on Facebook, such as ‘Like’, ‘Share’ etc. The users are able to setup their own ‘radio station’ based on the songs they love, as well as songs recommended by the system. The product uses Amazon S3 for storing the information and EC2 to operate; MongoDB and Tokio Cabinets are used for storing music.</p>
              <p>
              ShoutOuts tentatively competed with Apple Music and Spotify. Unfortunately, the client was not able to invest enough to become a significant competitor among  the leaders of the streaming music industry.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "touchpanel",
        src: "touchpanel",
        title:
          "Revolutionary app to replace expensive  devices which  opened many doors for us",
        mode_dark:true,
        product:
          {
            id: "touchpanel",
            head_image: "touchpanel",
            title: "TouchPanelControl.com",
            icons:['amx_logo'],
            desc: `
              <p>Web:  PHP, Node.JS,  Angular 2, Magento, Golang<br/>
              Devices:  Java Java ME, Netlinx, junit, testng <br/>
              Mobile (Android, iOS, Windows):  AudioToolbox, Speex, CoreGraphics, CoreAnimation, CFNetwork, libxml, SQLite, GCM, Speech to text, Text to speech. Android SDK, NFC, SIP, websocket, primus, redis, directX</p>
            `,
          text: `
          <div class="row">
          <div class="column">
          <p>
            <a href="https://store.touchpanelcontrol.com/" target="_blank">TPControl</a>  is the most exciting project we have worked on to date.  It allows its users to manage their <a href="https://www.amx.com/en-US" target="_blank">AMX controllers</a>  for home automation through a mobile phone instead of using   <a href="https://www.amx.com/en-US" target="_blank">AMX touch panels</a>.
          </p>
              <p>
              AMX systems are configured from modular hardware, allowing systems to be customized to meet current needs. Typically, AMX equipment is used in room automation for “smart houses”.
              </p>
              <p>
              In a simplified way, AMX controllers can be compared with a  server that handles various devices connected to it - in the AMX world,  the devices are all household appliances. AMX touch panels are much like a  tablet with open browsers  displaying “web pages”  which are coming from the server (controller).
              </p>
              <p class="without_margin_bottom">
              AMX uses its own language - NetLinx and/or Java Cafe Duet to program the controller.
              </p>
              </div>
              <div class="column">
              <p>Touch panels use their own markup language called TP4 to process and display the information coming from the controllers.</p>
              <p>
              Following this simplified method s of communication between AMX touch panels and AMX controllers, our multi platform application can be considered as the  ultimate browser, able to replace AMX touch panels with the user’s favorite device (iPhone, iPad, iPod Touch, Android or Win8) that has TPControl installed.
              </p>
              <p>
              The added benefit to using our application is that the user doesn’t have to pay for expensive AMX touch panels.
              </p>
              <p>
              Another benefit is that unlike common touch panels, TPControl is able to work with multi TP4 files and switch between them seamlessly  with one touch. It is also possible to control household appliances via mobile connection.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "gameit",
        src: "gameit",
        mode_dark:true,
        title:
          "Mobile gaming platform to promote any product in the most cost-effective way",
        product:
          {
            id: "gameit",
            head_image: "gameit",
            title: "Gameit.us",
            desc: `<p>Objective C, Leanplum, Fabric: Crashlytics, Branch, Stripe (for online payments)<br/> Services for showing Ads: UnitiAds, Vungle SDK-iOS, Ad Colony, CocoaPods</p>`,
            text: `
            <div class="row">
            <div class="column">
              <p>
              The project is based on a really revolutionary idea that allows its author to promote any product and to earn money from  people competing  to win a product. The project is a gaming platform which makes it fun for users to interact with  ads. The user can choose to play  various trivia games to win real prizes, or even earn coins or tokens (an internal currency that provides users with additional abilities  or discounts of between  60 to 80%  when purchasing their products).
              </p>
              <p>
              Users can also create an exclusive game with between 2 and 12.000 players and challenge the other players which they’ve included.
              </p>
              <p class="without_margin_bottom">
              The winner gets the prize, the others earn tokens or coins which can be used for buying products.
              </p>
              </div>
              <div class="column">
              <p>The user not only  sees his own scores, but also   the scores of the previous winner, as well as the  top 10 players - there are 2.000-3.000 users that use  this app daily. An In-App Purchase feature is also integrated into the app for purchasing  tokens and coins. Stripe service is used for online payments via credit cards.</p>
              <p>
              We developed and designed the app for the client from the ground up and supported it for over 3 years. The client received  significant investments once the app was released that allowed them to promote it even more widely. Unfortunately something went wrong, and the client’s business had to cease trading, but none the less, it was a pretty cool app with so much more potential to explore.
              </p>
              <p>
              Despite the company gameit.us suffering from ‘game over’ blues, you may still find many of their previous promotion campaigns, comment threads and app reviews online.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "truebill",
        src: "truebill",
        mode_dark:true,
        title: "A real-life subscriptions' analytics and managing tool",
        product:
          {
            id: "truebill",
            head_image: "truebill",
            title: "Truebill",
            desc: ``,
            text: `
            <div class="row">
            <div class="column">
              <p>
                <a href="https://www.truebill.com/" target="_blank">Truebill.com</a> is a unique system that is aimed at helping users to analyse all their subscriptions, as well as managing and analysing  bills which users pay monthly.
              </p>
              <p>
              The bills are ordered by the system from a  3rd party service (e.g. dropbox, office36, amazon, godaddy etc), which makes  it transparently easy for a user to see what they have been charged for. The system provides all users with the opportunity to cancel any subscription directly from  the backend, without having  to contact a 3rd party service directly.
              </p>
             </div>
             <div class="column">
             <p>
             The users are also able to set/see the rating of a 3rd party service , and based on those ratings, the users are able to make  better choices or find cheaper alternatives of the service that they use.
             </p>
            <ul class="without_margin_bottom">
            <li>
            Node.js and React were chosen for this project’s development.
              </li>
            <li>
            Plaid.com API was  implemented to obtain  information about users bills, payments and credit cards.
            </li>
            <li>
              Redux was used to control the app state.
            </li>
            <li>
              Relay/GraphQL were used for server/client side communication.
             </li>
             <li>
              D3.js was  chosen for  displaying graphical information.
              </li>
            </ul>
            </div>
            </div>
            `,
          },
      },
      {
        id: "games",
        src: "games",
        title: "Multiple attempts in our own games development journey",
        mode_dark:false,
        head_image:'games',
        head_title:'Games',
        colorBackground:'#eaeaea',
        head_text_before_icon:`<p> We developed a series of our own games using the <a href="https://www.anscamobile.com/corona/" target="_blank">Corona framework</a>. Games development  was 100% of our investment. We were trying  to turn something fun and exciting into money making. All of the ideas for the games, scenarios, graphics and sound were innovatively created  by the games development team. Our first game was quite primitive since we did not focus on necessarily developing a successful game, it was merely a first attempt in learning what would work best for us. However, because of being popularly associated with a trending  game at the time ‘Fruit Ninja’ , became a very  sought-after game and their iOS version had about 300K monthly downloads - that truly inspired us to continue with future games development projects.</p>`,
        head_text_icon:'coronalabs',
        head_text_after_icon:`
        <div class="row">
        <div class="column">
        <p>
        Some games have a really attractive game play. We brainstormed among ourselves to invent some incredibly attractive heroes, awe-inspiring cars and mind blowing accident  scenes for our Car Park Control game.
        Some games had revolutionary scenarios, such as Zombie Puzzle Invasion which combines “match 3” and RPG genres.
        </p>
        <p>
        Both Galaxy Defender and Titan Saga are pleasantly fun shooters with stunning cartoon graphics and cool audio effects.
        </p>
        <p class="without_margin_bottom">
        Witchy Halloween, Dragon Joyride, Tourtley Joyride and Airmaster are fun infinite games with simple press the screen control, that makes a hero go up once the screen is clicked and fall down once the finger has been removed.
        </p>
        </div>
        <div class="column">
        <p>There are magical things happening and obstacles that the game’s hero needs to overcome. The heroes and their vehicles have different personalities and behaviour traits, making these games worthy of your spare time.</p>
        <p>
        We were successful in developing the games and attracting  a significant audience all wanting to play, however after the initial investment period, we found  that the income generated from the games didn’t  cover our support expenses, therefore we decided to close the doors on our gaming  development adventure.
        </p>
        <p>
        Even so, our games development journey was a shining example of what incredible heights our experience can lead us towards, and  they deserve to be  mentioned in our portfolio.
        </p>
        </div>
        </div>
        `,
        group_products: [
          {
            id: "vikings",
            title: "VIKINGS & DRAGONS",
            text: `
            <p>This concept was a pleasure to work on, with rich graphics and colourful characters. Beautiful illustrated heroes and dragons battled it out in a Norse viking setting.</p>
            `,
            product_image:["vikings-1", "vikings-2"]
          },
          {
            id: "mystic",
            title: "MYSTIC MINERS",
            text: `
            <p>This game concept is a grat example of character and set design. The wonderfully textured blocked set was an editable playground for the characters.</p>
            <p>All the blocks were capable of being mined or built upon, providing the characters with resources, access to tunnels and caves as well as releasing monsters and treasures.</p>
            <p>Water and lava flowed throughout the sets, and provided the characters with obstructions. You could build bridges over them or release the water and lava to meet and have the forces of nature stop each other.</p>
            `,
            product_image:[
              "mystic-miners-1",
              "mystic-miners-2",
              "mystic-miners-3",
            ],
          },
          {
            id: "halloween",
            title: "SQUISHY HALLOWEEN",
            text: `
            <p>A seasonal spin off from the popular game "Squishy fruit", this tap game involved squishing pumpkins, bats and witches.</p>`,
            product_image:["squishy-halloween-1"],
          },
          {
            id: "carpark",
            title: "CAR PARK CONTROL",
            text: `
            <p>A car parking challenge app with two play modes, lots of characters and multiple maps. Lear more about this project in our <a href="/portfolio">portfolio</a>.</p>`,
            product_image:["car-park-control-1"],
          },
          {
            id: "christmas",
            title: "FLICKY CHRISTMAS",
            text: `
            <p>A holly jolly Christmas seasonal app, where you help Santa fill his sack with goodies by flicking them in one at a time.</p>`,
            product_image:["flicky-christmas-1"],
          },
          {
            id: "character",
            title: "CHARACTER & SET ILLUSTRATION",
            text: `
            <p>A few examples of our character and set design concept illustrations. Here at WDevs we can take your idea and give it life. <a href="/contacts">Contact us</a> and let us make your idea for a game into a reality.
            </p>`,
            product_image: [
              "character-1",
              "character-2",
              "character-3",
              "character-4",
              "character-5",
            ],
          },
        ],
      },
      {
        id: "california-crane-school-certification-system",
        src: "education",
        head_image:'education',
        mode_dark:false,
        colorBackground:'#FFD7D7',
        title:
          "Education and certification platform that was ahead of its time in a non-pandemic world",
        group_products: [
          {
            id: "california-crane-school-certification-system",
            product_image: ["californiacrane"],
            title: "California Crane School Certification System",
            desc: `<p>Node.js, Adobe Cordova, Android SD, FFMPG</p>`,
            text: `
              <p>
              A  unique testing platform developed for the United States Occupational Safety and Health Administration’s (OSHA) Crane Compliance. The platform provides a specific environment to manage the testing of crane operators, anytime and anywhere. The platform consists of the following functional modules:
              </p>
              <ul>
              <li>
              Android application for managing theoretical tests based on multiple-choice questions. The candidate has to answer the questions by selecting one of the proposed options. Some questions require using reference materials and making complicated calculations. Smart notes and engineering calculators are built into the application.
              </li>
              <li>
              Android application for test coordinators (TC) to manage the class during e examinations. TCs are  able to sign  candidates in who have been assigned to take the exam , see the status of each candidate’s test , as well as control and set up the video cameras which will control the class during the test.
              </li>
              <li>
              Android application for managing a practical examination which  has step-by-step instructions, as well as a  unique interface for the test coordinator to keep track of the progress from each finalised stage.
              </li>
              <li>
              OSHACC backend server equipped with the ability to  compile test questions using our exciting “Test maker” software. The backend allows to setup candidates, test coordinators, chief examiners, classrooms and other environments.  All candidates’ results ; including videos captured from different corners of the classroom, are stored  in the backend too.
              </li>
              <li>
              Proxy server is a gateway between the classroom and OSHACC backend server. It provides the connection  to various cameras to monitor the classrooms during  examinations, connects the test candidates’ Android tablets directly to their coordinator’s tablet , securely stores all examination results during their relevant sessions and then hands  them over to the main server after completion of the exams.
              </li>
             </ul>
             <p>The site of OSHACC is <a href="https://oshacc.org" target="_blank">https://oshacc.org</a></p>
            `,
          },
          {
            id: "rocketship-education",
            product_image:["rocketship"],
            title: "RocketShip Education",
            desc: `<p>PHP, Zend 2, JQuery, Doctrine</p>`,
            text: `
              <p>
                Being a Student Management System for teachers, this product helps teachers manage their students by tracking their grades, providing recommendations, uploading course information and assessment issues. Seven schools in Los Angeles are extensively using this system, which has <a href="https://www.nbcbayarea.com/news/local/rocketship_education_bay_area/1902106/" target="_blank">also caught the attention of the NBC recently</a>.  All the details of this project, which involved 5 developers working full-time on it, are available on the <a href="https://www.rsed.org/index.cfm" target="_blank">client’s website</a>.
             </p>
            `,
          },
        ],
      },
      {
        id: "ppc-editor",
        src: "google",
        title: "The app that Google wanted to purchase",
        mode_dark:true,
        product:
          {
            id: "ppc-editor",
            title: "PPC EDITOR FOR G1 (ANDROID)",
            desc: ``,
            head_image:'ppc',
            text: `
              <div class="row">
              <div class="column">
              <p>
                It's an old app that we developed during the earliest age of Android and it would not be reasonable to mention that app, if not for the fact that Google appreciated our app; as well as our development approach, and they were considering purchasing our app instead of developing their own.
              </p>
              </div>
              <div class="column">
              <p>
                There is nothing revolutionary about it today, but way back then Google had not yet developed  an app to manage their AdWords campaigns, so we saw it as a learning challenge and decided to bridge that gap by developing it ourselves.
                 Moreover, those days we promoted some of our products with the help of AdWords and decided that the tool would be pretty convenient for our marketing guys to remotely track expenses.
              <p>
              </div>
              </div>
            `,
          },
      },
    ],
    other_projects: [
      {
        id: "classiccar",
        src: "classiccar",
        mode_dark:true,
        title:
          "The ambitious website aimed to become the #1 competitor amongst 20.000 similar websites",
        product:
          {
            id: "classiccar",
            head_image: "classiccar",
            title: "ClassicCar.com",
            desc: ``,
            text: `
            <div class="row">
            <div class="column">
            <p>
              This ambitious website aims to be the definitive portal for both sellers and buyers of classic cars all over the world.Having already cooperated with more than 5000  vehicle selling sites, ClassicCar will eventually partner with more than 20,000 such websites.
              </p>
              </div>
              <div class="column">
              <p>
              Key  features of the website include an intelligent and flexible car classifying algorithm, amazing GUI using pure HTML 5,a Wiki-style ability for users to edit the information about  cars and an Asterix-based contact/inquiry mechanism for interested buyers to contact sellers.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "vpn",
        src: "vpn",
        mode_dark:true,
        title:
          "Virtual private network which allows users to surf  the Internet from any virtual location",
        product:
          {
            id: "vpn",
            title: "VPNManager.com",
            head_image: "vpn",
            desc: `<p>BGP; policy routing; pptp and l2tp VPNs; authorization, authentication and accounting via RADIUS; multi-routing-tables.</p>`,
            text: `
            <div class="row">
            <div class="column">
            <p>
              Being a multi-country virtual private network, VPNManager.com allows its members to surf the Internet as though they are surfing from any other country of their choice. This provides users with both  greater security and a consistent user experience, irrespective of where they are located.
              </p>
              </div>
              <div class="column">
              <p>
              The service comes with an easy GUI that lets users easily set up the rules for surfing,  e.g. a user could set the rule to see the UK edition of the BBC from a  UK VPN server, or open SSH - allowed to the US users only via US VPN server.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "quotation-junction",
        src: "quotation",
        title:
          "B2B/B2C lead-generation platform which connected buyers and suppliers all over the world for over  10 years",
        mode_dark:true,
        product:
          {
            id: "qj",
            title: "QuotationJunction.com (QJ)",
            desc: `<p>PHP, Zend, Jquery, Geo IP, Paypal, Authorize.net</p>`,
            head_image:'qj',
            text: `
            <div class="row">
            <div class="column">
              <p>
              QJ was founded in 2005 and was around until 2016. It was one of the most significantly ambitious, high revenue, and long-term projects to be taken up at the time and the dramatic cliffhanger for QJ was in 2015 when Google changed their policies which required affiliates to gain permission from each merchant they wished to promote, before being permitted to commence with an Adwords campaign. It made the model QJ had used for years, completely unsustainable.
              </p>
              <p>
              After trying to exist without Google AdWords for a while, QJ faced that they could not maintain their advertising expenses and they sadly stopped existing.
              </p>
              <p>
              Even so, it was a great system and we were happy to be their main developers.
              </p>
              <p>
              This impressive project was designed and developed from scratch, based upon clients' requests. Originally, Quotation Junction had fewer employees available than the number demanded. However, the project had evidently evolved into a large, ongoing development with 5 full-time developers and this ensured that there was still room for the clients' business plans and models to expand.
              </p>
              <ul>
                <li>In-built affiliate management, tracking and reporting system;</li>
                <li>Auction-based model for setting fees;</li>
                <li>Post-paid and prepaid payment models for merchants;</li>
                <li>Customer support ticket systems;</li>
                <li>Integrated blogs.</li>
              </ul>
              <p class="without_margin_bottom">
              QJ was a B2B/ B2C lead-generation platform that aimed to generate a high volume of quality leads to its participating vendors and merchants purely on a pay-for-performance model. The lead-generation service was  available in  over 25 categories of both small- and big-ticket products and services.
              </p>
              </div>
              <div class="column">
              <p>Prospective buyers could  submit generic "Request for Quotation (RFQ)" forms per product category, or product-specific RFQs and QJ would help buyers find the best supplier suited to the RFQ.</p>
              <p>
              Participating suppliers paid  a fee for every successful lead (RFQ) generated, which was  based on the category and the locations that they were  interested in.Additionally, the cost per lead could  be set by suppliers on an auction basis as well and   suppliers could  also control their marketing spend by specifying the maximum budget on leads per month.
              <p>
              There were  two types of suppliers: prepaid and postpaid. Pre-paid suppliers had  to top-up funds in their account to continue receiving leads from QJ, while postpaid suppliers had  to pay according to a monthly auto-generated invoice from QJ.
              </p>
              <p>
              QJ tracked  transaction histories  via  feedback from both buyers and suppliers, regarding  each other’s experiences. QJ also offered  excellent customer service with a LiveChat and  smart ticket system.
              </p>
              <p>
              All the content on the site was  managed  via an easy-to-use CMS. The main site administrator could  provide access to other users of the CMS with various  roles using a rights/permissions system that allowed  the users to read , write , edit and content.
              </p>
              <p>
              QJ also offered revenue generating opportunities for smart web publishers who could  participate in the QJ affiliate program and thereby got more suppliers/vendors to use the lead generation service. Besides an easy-to-use affiliate interface, the QJ affiliate management system helped affiliates generate revenues with excellent marketing support in the form of widgets and banners. They could also compile accurate reports and statistics on the performance of the various creative marketing tools, as well as all the commissions generated.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "parliament-today",
        src: "parlient",
        title:
          "UK Parliament monitoring service existed since 1966 (a long time before we had become used to using the Internet)",
        mode_dark:true,
        product:
          {
            id: "parliament-today",
            head_image: "parliament",
            title: "ParliamentToday.com",
            desc: ``,
            text: `
              <div class="row">
              <div class="column">
              <p>
                We have worked on this project development and support from 2009 till now.Since the site existed from the early years of the Internet and it was based on various outdated frameworks, in the period 2019-2021, the site was completely rebuilt to the modern platform based on Laravel/Vue.js. Considering that most subscribers are conservative UK gentlemen, we kept the interface similar to what the users had before.
              </p>
              </div>
              <div class="column">
              <p>
              This website parses the information about actions taken by the government on various issues and delivers it to thousands of subscribers using various sets of smart filters to deliver the qualified information only. There are thousands of subscribers and gigabytes of daily updated information are sent to the clients every day.
              </p>
              <p>
              The service provides AI news recognition taking the information from various sources, including Parsers, APIs, Voice-to-text, PDF-to-text, Pictures-to-text.
              </p>
              </div>
              </div>
            `,
          },
      },
      {
        id: "price-comparison-sites",
        src: "comparison",
        title:
          "A series of price comparison sites with abilities to clone the sites to promote specific goods in a certain area",
        mode_dark:true,
        product:
          {
            id: "price-comparison-projects-family",
            head_image: "price",
            title: "Price comparison projects family",
            desc: `<p>PHP, YII2 Gearman, Bootstrap, Angular</p>`,
            text: `
              <div class="row">
              <div class="column">
            <p>
            We’ve developed a number of price comparison family sites. Some of  the best examples are: ecompare.co.uk, compare99.com, price-click.co.uk, idealpricestore.com, pebble.co.uk, catwalk.co.uk, discountvouchers.co.uk, 18holes.co.uk, doingup.com, todaysfashion.com. The base of each of these sites  are to display, analyze and allow  a user to manipulate  information coming from various sources.
            </p>
            <p>
            The sources can be defined as:
            </p>
            <ul>
            <li>feeds provided by a  3rd party;</li>
            <li>modules to scrape information from open sources;</li>
            <li>manual data entering.</li>
            </ul>
            </div>
            <div class="column">
            <p>The sites are developed with various features to make the browsing more effective: </p>
            <ul>
            <li>Different variations of search criterias</li>
            <li>Detailed comparisons</li>
            <li>Smart suggestions of relevant products based on site browsing </li>
            <li>Various rating systems and comments</li>
            <li>Organising products in various lists (eg. watch later, favorite, custom, etc.)</li>
            <li>And many others.</li>
            </ul>
            <p>The main advantage  of the system is that its structure is completely module based. The logic of each site is placed beside CSS, therefore a new site can be created rather quickly. All the client needs to develop a new site is to define a set of modules he would like to use on the site, configure the modules and slice the design into the template. There is a wide range of various modules to make the site look attractive, though it is easy to develop the new ones both for features  and for new data sources.
            </p>
            </div>
            </div>
            `,
          },

      },
      {
        id: "pharmaceutical-system",
        src: "pharmaceutical",
        title: "Pharmaceutical system",
        mode_dark:true,
        product:
          {
            id: "pharmaceutical",
            head_image: "pharmaceutical",
            title: "Pharmaceutical system",
            desc: ``,
            text: `
              <div class="row">
              <div class="column">
              <ul class="first_list">
            <li>System sponsored by one of the biggest pharmaceutical companies to promote their products at chemists' shops and help them deliver medicines to consumers.</li>
            <li>
            Uses Perl as the underlying technology.</li>
            <li>
            A good example of our ability to work with other companies in system development, and produce large-scale systems and applications.
            </li>
            </ul>
            <p>
            It must be mentioned that we cannot take full credit for the development of the system, as one of the components to be used for PDAs using PalmOS was developed by another organization.
            </p>
            <p>
            The system is based on three dedicated servers, one of which receives requests from mobile devices and is used to synchronize mobile applications with the main system database using 'Net Update' module, developed by another company. The other two servers used for the work (a database (DB) server and HTTP server) were developed by us
            </p>
            <p>
            The DB server used a mySQL database to store the broad assortment of products from the pharmaceutical company. The front/back end server is an HTTP server that provides the system administrators with the ability to handle the base depot/ warehouse by keeping track of items and their assortment in the store.
            </p>
            <p>We chose Perl as a platform for the back-end for two reasons:</p>
            <ol>
            <li>to let HTTP server communicate with the Net Update server using the same programming language, and;</li>
            <li>the loading on the server is very high and we use threads to handle clients' requests to the server.</li>
            </ol>
            <p class="without_margin_bottom">Users of the system are authorised personnel or attorneys from the pharmaceutical company.</p>
            </div>
            <div class="column">
            <p>Usually, attorneys are the owners of drug stores and are authorised to enter new attorneys in the system. Attorneys provide "floating" pharmacists access to the system to let them see medical goods available to them.
            </p>
            <p>
            There are different types of floating pharmacists who are authorised to do different kinds of work for the system. Floating pharmacists visits patients to provide them with consultations, to sell pharmaceuticals or to provide them with nursing services. They immediately record all the services provided via the PDA application or via the back-end admin interface using a computer connected to the Internet. The floating pharmacists are able to prescribe medicines via PDA to end consumers.
            </p>
            <p>
            Drugstores reserve required quantities of medicines. Every time the inventory falls below a specified level, the goods are replenished to the required quantity. The system also provides a credit system to let some drugstores order products using an "after sold" payment method.
            </p>
            <p>
            Detailed reports are available to let the company keep track of key sales data and the most profitable drugstores as well as help devise strategies to incentivise drugstores.
            </p>
            <p>
            In the subsequent phase of the project that we are working on now, the customer would like to allow the system to include multiple drug manufacturers. This is a complicated phase of the project, where we have to cater for a much higher system loading than at present. The basis for granting rights and privileges/powers for different users will also be much more complicated than it is now. Besides allowing members to work with different drug manufacturers, the latter will also be able to set their own price for the services offered by the floating pharmacists. However, the price bracket will be set by the main system administrator.
            </p>
            </div>
            </div>
            `,
          },

      },
      {
        id: "traffic-generation-system",
        src: "trafficgeneration",
        title: "Traffic generation system",
        mode_dark:true,
        product:
          {
            id: "traffic-generation-system",
            head_image:'trafficgeneration',
            title: "Traffic generation system",
            desc: ``,
            text: `
            <div class="row">
            <div class="column">
            <p>
            Want to generate lots of traffic to your website by effectively promoting it in various user ratings' platforms? We've created a platform specifically for that, a very good example of a distributed system based on dozens of servers.
            </p>
            <p>Unfortunately, we aren't able to provide you with any URLs of the system (you'll understand why in a few minutes).</p>
            <p>As part of this system, about 300 mini-sites are managed via a main back-end system. Basically, the sites are from a family of catalogue websites. The main unit of the site is an advertiser's object with the information comprising title, picture, some description text and URL of the site. These objects are then grouped by categories and sub-categories defined for each advertising site by the admin.
            </p>
            <p>The advertised URLs are flexible and can be defined via the back-end. The URL of the same advertiser object may vary depending on the geographic location of the visitor, the referrer of the visit (the URL the visit comes from) and the time of visit. The system allows for some easy, passive revenue generation.
            </p>
            <p>One of the key requirements was to make the sites distinct from one another, which means that all advertising sites are hosted on different servers placed in different countries with the designs being noticeably different from each other.</p>
            <p>Likewise, links to advertiser objects had to be distinctive. For this reason, we used different artists to develop the designs. We also guaranteed this by using different teams to slice up the HTML code to prevent any suspicion that the sites originated from the same place.
            </p>
            </div>
            <div class="column">
            <p>We used cheap hosting for these advertising sites to reduce site support/ maintenance costs. Some hosting services only require databases to be connected from a local host and therefore we have developed a data transfer using SOAP class to be independent from libraries, which is often not included in standard PHP installation and not installed with shared hosting service providers.</p>
            <p>The sites attract considerable search engine traffic as a result of the content being frequently updated by dedicated content managers, as well as advertising in sponsored links on search results pages of most popular search engines.</p>
            <p>Detailed visitor tracking is provided to give the site owner complete visibility on the results of his/her advertising campaigns. You can imagine the size of the database and usage of the system from 300+ advertising sites where each site has 5000+ unique visits a day with complete stored information of visitor activity over a long period.</p>
            <p>The content and static data are separated by different servers to increase system productivity. One server is used for the back-end and it stores the content of the sites. Another server collects visitor tracking data. Quova(.com) software is installed on this server and the database imported daily from alayzespider.com to determine the town and city that the user visits from.</p>
            <p>The system is managed completely via the back-end. It wouldn't be possible for one person to manage the content of 300+ sites; nor is it reasonable to expect a person responsible for a particular advertising site to know all the advertisers of the system. A permissions system allows the main system administration to grant privileges to other system administrators or groups of system administrators. It is also possible to limit access to only a few sites or even create read-only administrative rights that allow the user to view statistics without the ability to modify any content.
            <p>
            </div>
            </div>


            `,
          },
      },
    ],
    designProjects: [
      {
        type: "gui",
        src: "gui/cisco",
        srcImage:"cisco-1",
        imagesForShow:4,
        video: false
      },
      {
        type: "logos",
        src: "logos",
        srcImage:"logo1mix-1",
        imagesForShow:1,
        video: false
      },
      {
        type: "mobile",
        src: "mobile/mix",
        srcImage:"mix-1",
        imagesForShow:2,
        video: false
      },
      {
        type: "printed",
        src: "printed/incubator",
        srcImage:"incubator-1",
        imagesForShow:3,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-1',
        src: "games",
        srcImage:"games-1",
        video: true
      },
      {
        type: "web",
        src: "web/bsidd",
        srcImage:"bsidd-1",
        imagesForShow:6,
        video: false
      },
      {
        type: "gui",
        src: "gui/tpc",
        srcImage:"tpc-1",
        imagesForShow:42,
        video: false
      },
      {
        type: "mobile",
        src: "mobile/waves",
        srcImage:"waves-1",
        imagesForShow:9,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-2',
        src: "games",
        srcImage:"games-2",
        video: true
      },
      {
        type: "web",
        src: "web/html-evolution",
        srcImage: "html-evolution-1",
        imagesForShow:17,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-4',
        src: "games",
        srcImage:"games-4",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-5',
        src: "games",
        srcImage:"games-5",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-6',
        src: "games",
        srcImage:"games-6",
        video: true
      },
      {
        type: "printed",
        src: "printed/tpc-printable-flyers",
        srcImage:"tpc-printable-flyers-1",
        imagesForShow:3,
        video: false
      },
      {
        type: "mobile",
        src: "mobile/mdm-deploy",
        srcImage:"mdm-deploy-1",
        imagesForShow:6,
        video: false
      },
      {
        type: "gui",
        src: "gui/parliament",
        srcImage:"parliament-1",
        imagesForShow:8,
        video: false
      },
      {
        type: "gui",
        src: "gui/vpn",
        srcImage:"vpn-1",
        imagesForShow:8,
        video: false
      },
      {
        type: "web",
        src: "web/irrigation-control",
        srcImage:"irrigation-control-1",
        imagesForShow:4,
        video: false
      },
      {
        type: "web",
        src: "web/avnon",
        srcImage:"avnon-1",
        imagesForShow:3,
        video: false
      },
      {
        type: "web",
        src: "web/shrewd-save",
        srcImage:"shrewd-save-1",
        imagesForShow:7,
        video: false
      },
      {
        type: "web",
        src: "web/rascrut",
        srcImage: "rascrut-1",
        imagesForShow:13,
        video: false
      },
      {
        type: "web",
        src: "web/hys",
        srcImage: "hys-1",
        imagesForShow:9,
        video: false
      },
      {
        type: "printed",
        src: "printed/tpc-posters",
        srcImage: "tpc-posters-1",
        imagesForShow:2,
        video: false
      },
      {
        type: "logos",
        src: "logos",
        srcImage: "logo2mix-1",
        video: false
      },
      {
        type: "gui",
        src: "gui/builder",
        srcImage: "builder-1",
        imagesForShow:37,
        video: false
      },
      {
        type: "gui",
        src: "gui/sprinkle",
        srcImage: "sprinkle-1",
        imagesForShow:29,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-7',
        src: "games",
        srcImage: "games-7",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-8',
        src: "games",
        srcImage: "games-8",
        video: true
      },
      {
        type: "mobile",
        src: "mobile/angel",
        srcImage: "angel-1",
        imagesForShow:3,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-3',
        src: "games",
        srcImage:"games-3",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-9',
        src: "games",
        srcImage: "games-9",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-10',
        src: "games",
        srcImage: "games-10",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-11',
        src: "games",
        srcImage: "games-11",
        video: true
      },
      {
        type: "mobile",
        src: "mobile/menu-food",
        srcImage: "menu-food-1",
        imagesForShow:3,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-12',
        src: "games",
        srcImage: "games-12",
        video: true
      },
      {
        type: "mobile",
        src: "mobile/goalbook",
        srcImage: "goalbook-1",
        imagesForShow:1,
        video: false
      },
      {
        type: "web",
        src: "web/cmg-labs",
        srcImage: "cmg-labs-1",
        imagesForShow:4,
        video: false
      },
      {
        type: "web",
        src: "web/tddg",
        srcImage: "tddg-1",
        imagesForShow:8,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-13',
        src: "games",
        srcImage: "games-13",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-14',
        src: "games",
        srcImage: "games-14",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-15',
        src: "games",
        srcImage: "games-15",
        video: true
      },
      {
        type: "printed",
        src: "printed/lera-work",
        srcImage: "lera-work-1",
        imagesForShow:3,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-24',
        src: "games",
        srcImage: "games-24",
        video: true
      },
      {
        type: "web",
        src: "web/classiccar",
        srcImage: "classiccar-1",
        imagesForShow:2,
        video: false
      },
      {
        type: "mobile",
        src: "mobile/menu-store",
        srcImage: "menu-store-1",
        imagesForShow:2,
        video: false
      },
      {
        type: "web",
        src: "web/tpc-web",
        srcImage: "tpc-web-1",
        imagesForShow:11,
        video: false
      },
      {
        type: "logos",
        src: "logos",
        srcImage: "logo3mix-1",
        video: false
      },
      {
        type: "gui",
        src: "gui/amx",
        srcImage: "amx-1",
        imagesForShow:22,
        video: false
      },
      {
        type: "games",
        videoSrc:'games-16',
        src: "games",
        srcImage: "games-16",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-17',
        src: "games",
        srcImage: "games-17",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-18',
        src: "games",
        srcImage: "games-18",
        video: true
      },
      {
        type: "web",
        src: "web/referto",
        srcImage: "referto-1",
        imagesForShow:5,
        video: false
      },
      {
        type: "mobile",
        src: "mobile/skypets",
        srcImage: "skypets-1",
        imagesForShow:6,
        video: false
      },
      {
        type: "mobile",
        src: "mobile/menu-hair",
        srcImage: "menu-hair-1",
        imagesForShow:13,
        video: false
      },
      {
          type: "mobile",
          src: "mobile/chevron",
          srcImage: "chevron-1",
          imagesForShow:4,
          video: false
      },
      {
        type: "games",
        videoSrc:'games-19',
        src: "games",
        srcImage: "games-19",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-20',
        src: "games",
        srcImage: "games-20",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-21',
        src: "games",
        srcImage: "games-21",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-22',
        src: "games",
        srcImage: "games-22",
        video: true
      },
      {
        type: "games",
        videoSrc:'games-23',
        src: "games",
        srcImage: "games-23",
        video: true
      },
      {
        type: "web",
        src: "web/price-click",
        srcImage: "price-click-1",
        imagesForShow:5,
        video: false
      },
      {
        type: "web",
        src: "web/linkd2",
        srcImage: "linkd2-1",
        imagesForShow:4,
        video: false
      },
      {
        type: "web",
        src: "web/dev-heroes",
        srcImage: "dev-heroes-1",
        imagesForShow:2,
        video: false
      },
      {
        type: "web",
        src: "web/lotery-rewards",
        srcImage: "lotery-rewards-1",
        imagesForShow:5,
        video: false
      },
      {
        type: "web",
        src: "web/traffic-junction",
        srcImage: "traffic-junction-1",
        imagesForShow:7,
        video: false
      },
      {
        type: ["gui","web"],
        src: "rocketship",
        srcImage: "rocketship-1",
        imagesForShow:3,
        video: false
      },
      {
          type: "printed",
          src: "printed/tpc-brochures",
          srcImage: "tpc-brochures-1",
          imagesForShow:2,
          video: false
      },
      {
        type: "web",
        src: "web/sage",
        srcImage: "sage-1",
        imagesForShow:3,
        video: false
      }
    ],
    magento_projects: [
      {
        title: `<a href="https://www.yorknow.com/" target="_blank">yorknow.com</a>, luxairenow.com`,
        src: "york",
        text: ` <p>
        This is a B2B project that is over two years of our support.
        </p>
      <ul>
        <li>
        Advanced B2B functionality that let the customers to add their employees to manage the wholesale purchase.
        </li>
        <li>
        A quite complicated theme spread for two brands of the company: yorknow.com and luxairenow.com
        </li>
        <li>
        A lot of 3rd party and hand-made extensions
        </li>
        <li>
        Multistore that suggests the nearest shop based on user's GEO location
        </li>
        <li>
        Complicated multiwarehouse system.
        </li>
        <li>
         Delivery over the USA with complicated delivery price calculation based on Day/Time, weight, price, and many other factors.
        </li>
        <li>A lot of 3rd party real time APIs integrated (for shipping, payments, stocks of partners)
        </li>
        <li>
        The project is connected to a few different ERP systems of the partners.
        </li>
      </ul>
      `,
      },
      {
        title: `<a href="https://marketplace.magento.com" target="_blank">marketplace.magento.com</a>`,
        src: "magento",
        text: ` <p>
        It was probably the most ambitious project I was involved in, because it was the project developed for Magento Commerce company itself. We implemented a new theme for Magento Marketplace. Marketplace has a rather uncommon functionality for Magento sites, which required a special approach in theme implementation process. The theme had to support single sign-on process over all Magento web sites. Moreover the theme has integration with a complicated Marketplace API developed by Magento core team.
        </p>
        <p>
        The coding was done in PSR4 coding style and it was constantly passing review by Magento team. Excellent delivery and compliance to the high coding standard proves our capabilities in Magento development.
       </p>
      `,
      },
        {
            title: `<a href="https://buissonniere.com/en/" target="_blank">A DIGITAL MAKEOVER OF A FASHION & APPAREL ONLINE STORE: BUISSONNIERE'S E-COMMERCE REVAMP</a>`,
            src:  "buissonniere",
            text: `
                <p>
                    Our client, a major player in the Belgian Fashion Apparel & Accessories market, operates both physical stores and a global online presence. They approached us to improve their e-commerce platform, which faced challenges due to a previous vendor's shortcomings.
                </p>
                <p>
                    Upon initial assessment, our team found the e-commerce platform in production but plagued with underdeveloped features. To start, we tackled critical issues and resolved numerous bugs that were hindering the platform's functionality. Once these were settled, we shifted our focus to the most intricate aspect of the project: integrating the platform with the third-party ERP system, Prios.
                </p>
                <p>
                    This involved syncing products, inventory, categories, customers, prices, images, orders, invoices, and returns. The task posed a significant challenge due to the nature of Prios' SOAP protocol API, which lacked flexibility. Our solution implied refactoring an existing connector to update the entire product catalog daily and inventory every 20 minutes, ensuring that the data remained current and accurate. This also entailed addressing issues and implementing request data caching.
                </p>
                <p>
                    The client was using version 2.4.2-p2, and while regular security patches were applied, we found it necessary to move the site to the latest version, 2.4.6. During this upgrade, we updated critical services such as PHP (to version 8.1), MySQL, RabbitMQ, and Redis. In the process, we also eliminated bugs and made the code compatible with the new PHP version to ensure seamless operation.
                </p>
                <p>
                    Our team used Adobe Commerce Cloud's New Relic infrastructure for real-time monitoring. This allowed us to proactively detect and address performance issues and errors, ultimately enhancing the store's performance. Furthermore, we integrated several Adobe Commerce SaaS Services into the platform, including Product Recommendations powered by Adobe Sensei, Live Search, Catalog Service, and SaaS Price Indexing, making it possible to use advanced marketing tools, better search capabilities, and catalog management.
                </p>
                <p>
                    As a result, our solutions have not only resolved critical issues and bugs but have also optimized the backend operations, streamlined data integration, and boosted the overall performance of our client's e-commerce platform. The successful execution of this project has resulted in a more efficient and user-friendly online shopping experience for their customers, reinforcing their position in the highly competitive Fashion & Apparel market.
                </p>
            `,
        },
      {
        title: `<a href="https://kukimi.de/" target="_blank">Kukimi.de</a>`,
        src:  "kukimide",
        text: `
        <p>
        Kukimi is an online store/consulting service for letting its clients manage balanced meals and optimised diets.
        </p>
        <p>
        It is the best example that demonstrates our experience in working with Magento based stores that are able to handle extremely high traffic. In peak loading coming after TV spots advertising, Kukimi manages 20.000 visitors and about 3000 purchases per hour.
        </p>
        <p>
        Kukimi is hosted on MS Azure cloud service, that contains 10 servers working in a cluster (4 app servers, 3 DB servers, 1 storage service for keeping media data and logs, 1 staging server for the development and 1 server is for beta testing of the most recent features). The app servers are tuned for Azure load balancer, that allows to distribute the loading between all app servers. In case of failure of any app server, the project continues to serve its visitors.
        </p>
        <p>
         DB cluster supports Master-Master data replication that is based on Percona and Galera, that allowed us to accelerate data manipulation in a few times. Moving data is always safe and in case of any DB server corruption, the project continues its safe working.
        </p>
        <p>
        Such significant and important project as Kukimi requires constant support and monitoring. Beside server monitoring provided by MS Azure we use Zabix servers monitoring tool that notifies us about any failures on the servers. So we are being notified about any potential issue, that allows us to be quick in problems solving.
        </p>
        <p> Kukimi has a lot of custom features as:</p>
        <ul>
          <li>
          Magento Products are presented as a program that contains the list of meals and these meals are listed for specific period. Kukimi consults and helps their consumers to take an optimal menu to see it online, to make changes to the menu and then to get a product with detailed instructions how to cook and to use the purchased product.
          </li>
          <li>
          There is a flexible delivery system, that a user may choose. The user may receive the whole purchase immediately, as well as to be able to receive products on daily/weekly base, paying for the purchase in parts.
          </li>
          <li>
          Kukimi uses custom CRM to manage their clients/products that is synced with Magento based store.
          </li>
          <li>
          There are a lot of various custom reports that allows Kukimi to foresee users demand for specific products.
          </li>
          <li>
          The site is presented in responsive design that allows the clients to use the power of Kukimi unique service on their mobile devices, as well as on computers.
          </li>
          <li>
          Currently we are migrating Kukimi to Magento V2.1 in order to have better server loading optimisation and integration with Kukimi CRM.
          </li>
      </ul>
        `,
      },
      {
        title: `<a href="https://www.orthocanada.com/en/csc-migration" target="_blank">Clinic Supplies Canada</a> (CSC)`,
        src:  "csc",
        text: `
        <p>
        CSC is a supplies leader for medical clinics. It works with more than 1000 clinicians. CSC sells everything related to medical equipment. Its customers have the biggest choice of brands and products in Canada. CSC online business was founded in 2006. CSC requested our support early in 2014. We optimized and redesigned the site significantly to make it quick for browsing thousands of products that they have. We developed the following features:
      </p>
      <ul>
        <li>
        A user doesn’t even have to browse over too many categories, looking for a specific product. We developed a unique “Shop by Injury” feature. Everything the user has to do is to specify the injury that he has and to  select answers for 3 easy questions. The relevant products will be displayed afterwards.
        </li>
        <li>
        To make the purchasing process easier for buyers, we modified Magento checkout functionality to let it work in “One Page Checkout” style, that allows users to purchase in a few clicks operating with complete order information displayed on the same page.
        </li>
        <li>
        CSC adds many products the same day the products have been requested by a buyer. A custom feature allows the customers to request products via a wishlist. The users are also able to request updates for the products that are out of stock.
        </li>
        <li>
        To simplify the work  of CSC managers, we implemented smart orders management, that allowed CSC admins to see complete information about the orders on the same page, as well as process the orders and manage them faster.
        </li>
        <li>
        Once a CSC manager has confirmed the order, an integrated ERP service receives complete information about the order and now can  manage the statuses of the order.
        </li>
        <li>
        CSC used an amazing Advanced Report extension that allowed them to make orders reporting by various criteria. The extension though was not able to manage exporting such a long list of orders that CSC has. We modified the extension, updating it with many new custom reports. Moreover, we allowed it to generate reports of unlimited export files size generated in background mode. Once exporting has been completed, the admin receives an email with the link to download the just generated file.
        </li>
        <li>
        CSC has over 70 various extensions installed. Unfortunately, there were many conflicts between the extensions, therefore most of the extensions were modified and optimized by us so that they don’t conflict with each other.
        </li>
    </ul>
    <p>The site was migrated to Magento 2.1.9.<br/>
    The beta version of the M2 version of the site could be reviewed at the link below: <a href="https://cscm2.p.webdevs.us/" target="_blank">https://cscm2.p.webdevs.us/</a></p>
        `,
      },
      {
        title: "QGAirsoft",
        src:"qg-main",
        text: ` <p>
        It is the one of the best examples to demonstrate our deep knowledge of Magento architecture. Initially the store was built on OSCommerce, though augmentation of assortment and various requirements of the client caused migration of the site from OSCommerce to Magento. Initially another team managed the migration, however Magento version was not polished for a long time, that forced the client turn to us with the request to optimize Magento instance. Unfortunately, the architecture of the site was not built well and there were so many problems with Magento implementation, that we decided to rebuild Magento version completely, so:
      </p>
      <ul>
        <li>
          We developed a migration script to export data from OSCommerce to
          Magento.
        </li>
        <li>
        We expended magento cache logics and improved default Magento cache accelerator.
        </li>
        <li>
        We designed and implemented a new theme for both mobile and desktop version of the site.
        </li>
        <li>
        There were about 170 various extensions set on OSCommerce. We found all relative extensions for Magento and updated them to completely replicate common functionality of OSCommerce version.
        </li>
      </ul>
      <p>Now we have:</p>
      <ul>
      <li>
        One step checkout with awesome Ajax effects that allows the user
        to add items quickly and improves the checkout pages appearance.
      </li>
      <li>
        Flexible discounts logic that allows the admin to configure
        discounts swiftly and allow the final user to see discounts
        directly on the products page.
      </li>
      <li>
        Advanced referral logic that allows the admin to set up referrals
        in their own preferred manner eg. buying X product X from Y
        category and receiving a payment of $Z, as well as the ability to
        set a number of rules for different kinds of users, to let them
        receive a referral fee. Bonuses can also be obtained by both the
        referred user and the user who invited them.
      </li>
      <li>
        Advanced SEO logic: We developed a module which automatically
        sorts through the contents of the pages and makes them SEO
        friendly. The module automatically adds SEO tags to all pages, it
        adds links and optimizes the structure of the HTML code for search
        engines.
      </li>
      <li>
        Advanced ERP functionality: Stores, remainders of products, smart
        alerts, notifications rules, errors tracking on stores, etc.
      </li>
      <li>
        The Sphynx based search works pretty quickly without significantly
        overloading the server.
      </li>
      <li>
        Wide abilities for the admin to customize various views of the
        site:
        <ul style="list-style-type: '▸ '">
          <li>
            Fully customizable main menu and submenu view, admins don’t
            need to be technical to change the look of the sub-menu.
          </li>
          <li>
            The customizable products’ list page view includes
            customizable filters for different products’ categories.
          </li>
          <li>
            Admin doesn’t have to be technical to customize products page
            enabling or disabling and customizing any structural content.
          </li>
        </ul>
      </li>
    </ul>`,
      },
      {
        title: `<a href="https://ecommerce.aheadworks.com/magento-extensions/points-rewards.html" target="_blank">ecommerce.aheadworks.com</a>`,
        src:  "aheadworks",
        text: ` <p>
        The module provides Flexible Points & Rewards rules that allow customers to earn different number of points while buying products from various categories, with certain SKU, price, or any other item attribute.
        Originally, the module was developed by AheadWorks team. We were subcontracted to develop Magento 2 version of the module.  Actually, porting of extensions from M1 to M2 is process of developing extensions from scratch, because M2 dictates completely different approach to modules development. The module is available at <a href="https://marketplace.magento.com/aheadworks-points-and-rewards.html" target="_blank">Magento Market Place</a>. The module is compliant to PSR2 Standard.
      </p>
     `,
      },
      {
        title: `<a href="https://www.transactcampus.com/" target="_blank">Sequoiars.com</a>`,
        src: "transact",
        text: ` <p>
        The company has its own e-commerce solution. The solution was developed as an extension of Apache. There are many <a href="https://www.transactcampus.com/" target="_blank">Sequoiars.com</a> clients who used their e-commerce solution: https://epos1.sequoiars.com.</p>
        <p>
         Though the solution became outdated and the company decided to migrate it to Magento 2 Enterprise Edition.
      </p>
      <p>
      The project is still under development. The key features are:</p>
      <ul>
      <li>
Multi store with various admins privileges to control stores (over 100 stores to be migrated to the new system)
</li>
<li>
Cloud hosting based architecture with integrated mySQL cluster and Azure based load balancing, that would allow to expand the system capabilities with the clients sites number of visitors grow.
</li>
<li>
Various options for bundles configuration to allow new store owners to be able to define their bundle product quick.
</li>
<li>
Stock Control System integration with ERP of <a href="https://www.transactcampus.com/" target="_blank">sequoiars.com</a>
</li>
<li>SCS integration with POS-terminals platform of the client.</li>
<li>Integration with 3-rd party tax calculation service.</li>
<li>Implementation of a set of generic themes with advanced admin tools to customize the layout via back-end</li>

     `,
      }
    ],
    blog: [
        {
          id:'openai-account-banned-for-policy-violations',
          img_src:'/blog/openai-account-banned-for-policy-violations',
          title:'OpenAI Account Got Banned For Policy Violations You Never Committed',
          desc:`
          <p>An OpenAI account can be shut down for policy violations the owner never committed, triggered by end-user abuse of a public endpoint. Rotating keys rarely fixes it. Here's why it happens, why "I already have the Moderation API" isn't enough, the guardrail tools worth knowing, and the protective layer we add for clients.</p>
          `,
          tags:['AI Agents','LLM','OpenAI','Cyber Security','Production','Business Automation'],
        },
        {
          id:'why-ai-agents-break-in-production',
          img_src:'/blog/why-ai-agents-break-in-production',
          title:'Why AI Agents Break In Production: Anatomy Instead Of Magic',
          desc:`
          <p>You can build an AI agent in five minutes, but production is a different story: runaway token bills, loops that won't stop, and one agent that ran terraform destroy on a live environment. The models aren't the problem, everything built around them is. Here's the 9-step anatomy we use to ship agents that survive real traffic.</p>
          `,
          tags:['AI Agents','AI-driven solutions','Business Automation','Custom Web Development','LLM','Production'],
        },
        {
          id:'hopways',
          img_src:'/blog/hopways',
          title:'Hopways - simplifying school journeys for everyone',
          desc:`
          <p>Hopways is a new service designed to take the stress out of school commutes, offering parents a reliable subscription-based solution for getting their children to school. The idea behind Hopways is straightforward: parents, especially those with busy schedules or a bit more flexibility in their budget, can set up consistent, dependable transportation for their kids, whether they need it every day or just on certain days of the week.</p>
          <p>What sets Hopways apart is its high standard for selecting drivers. The company goes beyond basic background checks, implementing a multi-step process that carefully screens each driver for safety and experience. The process starts with a detailed application, where drivers provide information about their driving history and qualifications. They also need to submit specific documents that validate their experience, licensing, and adherence to local safety regulations.</p>
          `,
          tags:['Custom Web Development','Web Design'],
        },
        {
            id: 'magento-vs-woocommerce-showdown',
            img_src: '/blog/magento-vs-woocommerce-showdown',
            title: 'Magento vs WooCommerce for your business',
            desc: '<p>WooCommerce vs Magento: Your WDEVS guide to select the best e-commerce solution. Our article explores key features, scalability, and insights to aid your choice.</p>',
            tags: ['WooCommerce', 'eCommerce', 'Magento', 'Custom Web Development', 'Cyber Security', 'Online Shopping', 'Enterprise Web Solutions', 'WordPress']
        },
        {
            id: 'chat-gpt-integration',
            img_src: '/blog/chat-gpt-integration',
            title: 'Enhancing E-Commerce With ChatGPT',
            desc: '<p>Transform your e-commerce platform with custom AI-driven solutions by WDEVS to boost customer satisfaction, and elevate your online store\'s performance!</p>',
            tags: ['ChatGPT Integration', 'eCommerce', 'AI-driven solutions', 'Custom Web Development', 'OpenAI', 'Business Automation', 'Natural Language Processing']
        },
        {
            id: 'handling-massive-product-db-in-magento',
            img_src: '/blog/handling-massive-product-db-in-magento',
            title: 'Handling Massive Product Databases In Magento',
            desc: '<p>From seamless user experience to scalable solutions, WDEVS are experts in developing Magento storefronts that redefine online retail</p>',
            tags: ['Magento', 'eCommerce', 'Data Import', 'Product Database', 'Magento Database', 'Custom Web Development', 'Online Retail', 'Magento Services']
        },
        {
            id: 'driving-sales-home-for-the-holidays',
            img_src: '/blog/driving-sales-home-for-the-holidays',
            title: 'Driving sales home for the holidays: simple web development solutions for boosting e-commerce during the holidays',
            desc: '<p>WDEVS offers expert insights and strategies to boost your online sales during high season. Discover effortless web development solutions to elevate your online business!</p>',
            tags: ['Magento', 'eCommerce', 'Data Import', 'Product Database', 'Magento Database', 'Custom Web Development', 'Online Retail', 'Magento Services'],
        },
        {
            id: 'vape-shop-custom-website',
            img_src: '/blog/vape-shop-custom-website',
            title: 'Why your vape shop needs a custom website?',
            desc: '<p>WDEVS offers cost-effective custom web development solutions for vape stores worldwide.</p>',
            tags: ['Magento', 'eCommerce', 'Vape Store', 'Custom Web Development', 'Web Design', 'Magento Services']
        },
        {
            id: 'shopify-limitations-for-e-commerce',
            img_src: '/blog/shopify-limitations-for-e-commerce',
            title: 'Shopify\'s Limitations For E-Commerce Business',
            desc: '<p>Thinking about migrating from Shopify? WDEVS ensures secure website migration from Shopify to any other platform you choose.</p>',
            tags: ['Shopify', 'Adobe Commerce', 'eCommerce', 'Website Migration', 'Custom Web Development', 'Shopify Restrictions', 'Online Store', 'Magento Services']
        },
        {
            id: 'adobe-commerce-vs-magento',
            img_src: '/blog/adobe-commerce-vs-magento',
            title: 'Adobe Commerce Vs. Magento: Choosing The Ultimate Solution For E-Commerce',
            desc: '<p>WDEVS provides Adobe Commerce Cloud and Magento development services for all stages of the e-commerce project life cycle.</p>',
            tags: ['Magento', 'Adobe Commerce', 'eCommerce', 'Custom Web Development', 'Adobe Commerce Cloud', 'Magento 2', 'Web Development Services']
        },
        {
            id: 'buissonniere-e-commerce-success-story',
            img_src: '/blog/buissonniere-e-commerce-success-story',
            title: 'Navigating fashion & apparel online: Buissonniere\'s e-commerce success story',
            desc: '<p>The Fashion & Apparel market is extremely competitive and saturated. With so many businesses vying for consumer attention, it can be difficult for a new brand to stand out and make a name for itself. Our client is a growing Belgian e-commerce company with several offline shops and worldwide shipping. Their existing online platform faced several challenges at some point, including underdeveloped features and numerous bugs, that’s why they decided to reach our experienced team.</p>',
            tags: ['eCommerce', 'Custom Web Development']
        },
        {
            id: 'outsourcing-company-vs-recruiting-agency',
            img_src: '/blog/outsourcing-company-vs-recruiting-agency',
            title: 'Hiring with Outsourcing Company vs Recruiting Agency',
            desc: '<p>WDEVS offers an experienced dev team for your project with no extra fees or hidden payments. You pay for what you really need!</p>',
            tags: ['eCommerce', 'Custom Web Development', 'Talent Acquisition', 'Recruitment', 'White Label']
        },
        {
            id: 'magento-code-review',
            img_src: '/blog/magento-code-review',
            title: 'The Ultimate Guide to Magento Code Review',
            desc: '<p>WDEVS provides a detailed code audit to ensure the functional performance of your Magento store is top-notch.</p>',
            tags: ['Magento', 'eCommerce', 'Custom Web Development', 'Code Audit', 'Code Review', 'Magento Services']
        },
        {
            id: 'code-review',
            img_src: '/blog/code-review',
            title: 'Code Review And How It Really Benefits Your Business',
            desc: '<p>In the world of rapidly developing startups & successful ecommerce product distribution platforms, every decision you make can dramatically affect your business. Either helping you be triumphant in the competitive market, or losing your clients; and as a result, your profits.</p>',
            tags: ['Code Review', 'eCommerce', 'Custom Web Development', 'Security', 'Outsourcing Web Development']
        },
      {
        id:'keep-afloat-by-outsourcing-web-development-during-recession',
        img_src:'/blog/keep-afloat-by-outsourcing-web-development-during-recession',
        title:'Outsourcing Web Development During a Recession',
        desc:`
          <p>Many signs are currently indicating that the global economy is heading towards a recession. According to a World Bank report, economic growth is expected to slow down in 2023 - even more drastically than was previously expected, because the ongoing war in Ukraine has negatively affected prospects for a post-COVID economic recovery, especially in Europe and North America.</p>
        `,
        tags:['Magento Outsource', 'eCommerce', 'Custom Web Development', 'Magento Services'],
      },

      {
            id:'security-audit',
            img_src:'/blog/security-audit',
            title:'Case study: the client`s Magento site was compromised',
            desc:`
            <p>One of our clients recently launched their new e-commerce website, and due to the lack of an in-house dev team, was seriously concerned about possible website safety issues. Of course, each Magento webstore has its own custom specifics and configurations, however, if you don’t pay attention to conducting thorough and regular security checks, it can lead  to potential risks & data breaches. We trust that the shared case below, will serve as a good example of the importance of Magento security audit services, and the subsequent improved effectiveness. WDevs performed a complete site audit for our client, to analyze and  identify vulnerabilities, as well as improve overall website performance.

            </p>
        `,
            tags:['Magento Audit', 'eCommerce', 'Security Audit', 'Security Patches', 'Magento Services'],
        },
      {
        id: 'razzo',
        img_src:'/blog/razzo',
        title: 'Scale up your eCommerce business with Razzo',
        desc:`<p>With this powerful & easy-to-use Razzo tool, you can be sure your online marketing delivers the most accurate data in simple and informative graphics. Special features help you analyze your clients’ needs & customer behaviour for any period of time you choose. Perfect choice for Magento-based website owners!</p>`,
        tags:['Ecommerce Dashboard'],
      },
      {
        id:'erp',
        img_src:'/blog/erp',
        title:'A complete introduction to ERP integration with ecommerce',
        desc:`<p>Within the past  few years, we have received many  requests for Magento/ERP integrations. Some clients found us  through our valuable partner Firebearstudio.com, who has done an enormous amount  of work for ERP integrations, and they have a <a href="https://firebearstudio.com/the-improved-import.html" target="_blank">brilliant tool</a> that could/can also be used as the base for any 3rd party system integration.</p>
        <p>We've accomplished a number of valuable projects integrating Merlin, NetSuite, Salesforce and MSDynamics. However, the most significant problem that we've faced is that the clients who came for the solution, expected to receive a ready-to-use version  which  could integrate the desired ERP to the Magento instance directly  after  installation. In a perfect world, that’s really what  we'd like to present,   however, an integration with a one-time installation exists only in an ideal world or in the unique case of the Client having  a default ERP configuration, as well as a  Default Magento instance already. In the real world, most Clients who desired to integrate ERP to Magento, were enterprise Clients with thousands of products in stock, well polished (read as: customized) processes, and complicated  sets of rules,   therefore an integration required a deep investigation into  the Client's DB structure, as well as  the working process. Consequently, integration required custom work rather than installing a ready solution. Despite the fact that we had a vast amount  of previous integration work  that we could reuse, the clients were often disappointed with the initial estimation that overcame their initial budget expectation. In this article, we'd like to outline why ERP/Magento integration is not as easy a task as it  may initially seem. </p>
        <p>However, once the integration is done, the Client receives the  ultimate solution that helps him  avoid most  routine work and also  allows him to have all his data in place, saving a great deal  of money and preventing costly mistakes related to  warehouse accounting.<p>
        `,
        tags:['ERP integration','Netsuite','Salesforce','Merlin','Connectors','Synchronization'],
      },
      {
        id:'home-delivery-date',
        img_src:'/blog/home-delivery-date',
        title:'Custom home delivery date & time solution for ecommerce',
        desc:`
        <p>In the past few years,  we’ve already grown accustomed  to speedy online orders & food delivery,  thanks to global pandemics, innovative digital technologies, and remodeled consumer expectations, and  the next industry to embrace these changes is Pharmacy/Pharmaceuticals & Healthcare. More & more big eCommerce players from different countries consider medicine/medicinal/medical industry home delivery as a new way to conveniently make their customers' lives easier, especially for those with limited mobility.
        </p>
        <p>
        One of our recent clients is a growing EU-based Pharmacy online store. He reached out to us with a request to create a custom solution for delivery schedule planning. His Magento 2 website offers a wide range of  medical products & appliances as a round-the-clock service – no wonder the delivery time plays a crucial role, and delivery day and hours should be defined even before the user starts shopping.</p>
        `,
        tags:['Healthcare','Delivery date'],
      },
    ],
    magento_feedbacks: [
      {
        id: 1,
        companyName:"Vivo Wholesale Inc.",
        name: "Vitali Fosnyuk",
        profession: "CEO",
        content: `"We have been working with WDevs for just a year and plan to work with them for many more. They offer excellent service, provide fantastic support and are always updating our system.   The team at WDevs always make sure that everything runs very smoothly and they have made sure our business' needs have been met. They have helped us with any and all issues we have had with Magento in a very timely manor. We are extremely happy with their services and highly recommend them."`,
        company: "Vivo Wholesale Inc.",
        address: "3775 W. Teco Ave Ste 6, Las Vegas,NV 89118",
        phone: "+1 (702) 551 0011",
        linkSite: `<a href="https://vapewholesaleusa.com/" target="_blank">vapewholesaleusa.com</a>`,
        email: `info@vivowholesale.com`,
      },
      {
        id: 3,
        companyName:"ClinicSuppliersCanada.com",
        name: "Sharon Chang",
        profession: `General Manager`,
        content: `General Manager of <a href="https://clinicsuppliescanada.com" target="_blank">clinicsuppliescanada.com</a> business, the website is based on Magento e-commerce engine.
        "At very beginning, our work with Andrey, Igor and his team at Webdevs aimed to just customize one of our purchased extension, we were thrilled with the result. 6 months later Webdevs is our only web development partner. Andrey and Igor's team are like superheros solving our never ending website development challenges and help us build our dream site that aligned with our corporate strategic plan. What we appreciated most about working with Andrey and his team was their ability to respond to our inquiries, keep everyone informed, and deliver the expected results. Their outstanding customer service has made our partnership one of the best!"`,
        linkSite: `<a href="https://clinicsuppliescanada.com" target="_blank">clinicsuppliescanada.com</a>`,
        phone: "+1 (877) 855 8818",
        email: `sharon@clinicsuppliescanada.com`,
      },
      {
        id: 4,
        companyName:"Kukimi.de",
        name: "Timm Langhorst",
        profession: "CTO",
        content:
          "Magento project which is over an year under our support and development. The server is based on MS Azure. The project is oriented to have over 50K of active visitors. The client has a lot of TV spots, in time of which the peak load happens.",
        linkSite: `<a href="https://kukimi.de/" target="_blank">kukimi.de</a>`,
        email: `timm.langhorst@kukimi.de`,
      },
      {
        id: 5,
        companyName:"Moogento.com",
        name: "Jim Gilbert",
        profession: "Founder",
        content: `We closely cooperate with <a href="https://moogento.com/ target="_blank">Moogento.com</a>, providing services of Magento 2 extension development and services of clients' support.`,
        linkSite: `<a href="https://moogento.com/" target="_blank">moogento.com</a>`,
        email: `splitlife@gmail.com`,
      },
      {
        id: 6,
        companyName:"Instagopher  — Grocery and liquor stores in Nassau Bahamas",
        name: "James",
        profession:
          "CEO Instagopher",
        content: `"We’ve had the pleasure to work with WDevs for the last 8 months and have had an exceptional experience. The work we requested has  always been completed on time and their communication has been nothing short of great. WDevs have worked along side our current developer and solved all of the issues that we faced. I would recommend WDevs to anyone that needed frontend or backend website development work they know their stuff. WDevs has never been unable to solve any of the customizations request that we made. I can’t thank them enough for their time and work I thought about changing to another platform, but I didn’t have to thanks WDevs. We would never think of using another company and look forward to working with WDevs in the future."`,
        linkSite: `<a href="https://www.instagopher.com/" target="_blank">instagopher.com</a>`,
        phone: "242 809 7312",
        email: `james@instagopher.com`,
      },
      {
        id: 7,
        companyName:"Livewelltoday.co.uk",
        name: "Shaun Casey",
        profession: "CEO",
        content: `"We have been working with WDEVS for over a year. They have worked alongside our current developers without fault and offered help and support when required. They have been involved in a number of projects with us and have helped us develop, integrate and customise Magento 2 plug-ins. I would have no hesitation in recommending this company."`,
        linkSite: `<a href="https://www.livewelltoday.co.uk" target="_blank">livewelltoday.co.uk</a>`,
        email: `shaun@livewelltoday.co.uk`,
      },
      {
        id: 8,
        companyName:"QGgairsoft.com.br",
        name: "Paulo Caetano",
        profession: "CTO",
        content: `"I'd like to thank WDevs team. This is by far one of the best developer teams I have worked with. Their support is really amazing. The manager is always online on Skype so if any problem appears we contact him in real time and he arranges a way to fix it. Also the quality of the solutions presented is very high and they truly know how to work with Magento. It's been a pleasure and I recommend them for sure."`,
      },
      {
        id: 9,
        companyName:"Belomax.be",
        name: "Maxim Van Broeck",
        profession: "CEO",
        content: `"Working with Wdevs is working with professionals. We had some Magento issues and wanted to change our store frontend. Wdevs has helped us in any possible way and understood straight away what our plan was. For any frontend or backend Magento change i would recommend Wdevs."`,
        linkSite: `<a href="https://belomax.be" target="_blank">belomax.be</a>`,
      },
      {
        id: 10,
        companyName:"Ignitioncbs.co.uk",
        name: "Elliot Paynter",
        profession: "Director",
        content: `"We’ve been working with WDevs on a complex e-commerce ERP integration project and what I’m impressed with is not only are they technically very competent but also excellent project managers and also proactive. This really helps me to keep the project moving forward."`,
        linkSite: `<a href="https://www.ignitioncbs.co.uk/" target="_blank">ignitioncbs.co.uk</a>`,
        email: "elliot@ignitioncbs.co.uk",
      },
      {
        id: 11,
        companyName:"Legends MKT",
        name: "C. R. Lefort",
        profession: "Technical Manager",
        content: `"
            We have worked with WDEVS for 6 months to manage, migrate and upgrade our busy ecommerce platform based on Magento 2.

            Our WDevs team who consist of a project manager, front-end and backend developer, DevOps engineer and QA specialist have enabled us to successfully upgrade our ecommerce platform, stabilize and secure our  infrastructure, implement a much needed CI/CD source control framework with Docker containers, and migrate our servers to 2.4.3.

            The team has consistently shown dedication, technical expertise, a high degree of dependability and a great capacity for problem solving. Most importantly their expertise in Magento has enabled us to grow our platform and prevent critical downtime.

            We were very impressed with the quality of the reporting WDEVS provided and their ability to coordinate their team efforts when solving problems under pressure while being very transparent.

            Documentation and communication in English has been very satisfactory and in every aspects the team has exceeded our expectations.

            We have been able to give them full access to our infrastructure and fully trust them with security, and we are now pleased to have the team alongside us to grow our platform and support us through future evolutions.

            Magento is a complex architecture and a very demanding ecommerce platform that requires a mix of technical skills that are hard to find. The quality of the work done by WDEVS and their dependability are second to none. We are most grateful to have them on board.
          "
        `,
        company: "Legends MKT",
        address: "Playa del Carmen, QROO Mexico",
        email: "claude@legendsmkt.com ",
      },
    ],
    razzo_feedbacks: [
      {
        id: 1,
        // companyName:"Vivo Wholesale Inc.",
        // name: "Vitali Fosnyuk",
        // profession: "CEO",
        content: `One of our clients reached us because he was unsure about reports he received from his marketing agency. For example, getting a revenue of 300.000 DKK last January, he did not feel the numbers matched the real situation. Razzo allows you to select a particular period and get the data straight from your website. Moreover, you can compare it with the previous period. Complete overview via simple graphs thanks to Razzo widgets.`,
      },
      {
        id: 2,
        // companyName:"Zakwatch.ch",
        // name: "Dominik Meier",
        // profession: "Co-Founder",
        content: `Another client of ours used Razzo’s Product Recommendations widget for his Magento store to show the visitors relevant complementary products. Offering more items, he boosted his monthly revenue up to 220%!<br/>
        Thanks to Razzo’s integration with Magento platform, you can easily connect your website using API. That’s it, nothing more! 😉
        `,
      },

    ],
    home_feedbacks: [
      {
        id: 1,
        companyName:"TouchPanelControl",
        name: "Camran Boyle",
        profession: "Co-owner and Customer",
        content: `TPC have worked with WDevs for almost a decade and built a strong reliable relationship with WDevs over this period of time.<br/>
        The WDevs team bring with them a lot of hard working a dedicated team members and no task seems to be challenging for them.<br/>
        During our tenure our team alongside WDevs have built a number of platforms and award winning products that have been globalized, sold on the market and acquired. We have used the latest in modern architecture including React and Angular designed as microservices to efficiently scale when required. We believe testing is a crucial part of development and WDevs incorporate TDD and Selenium to ensure product code delivery is more accurate for each build and creates less down time. The team has a vast knowledge of development skills, whether coding for iOS, GO, Web or embedded systems, with all team members incorporating continuous development through online and offline training and education.<br/>
        The quality and standards that are used throughout product development, coupled with agile team frameworks based on SCRUM and KANBAN is second to none. With a thriving culture, critical thinking and modern development frameworks, WDevs exceeds expectations.
        `,
        company: "TouchPanelControl",
        address: "Level 8/ 97 Creek Street, Brisbane, QLD, Australia, 4000",
        phone: "+614 32 018 009",
        linkSite: `<a href="https://store.touchpanelcontrol.com/" target="_blank">touchpanelcontrol.com</a>`,
        email: `camran.boyle@touchpanelcontrol.com `,
      },
      {
        id: 2,
        companyName:"G2i Inc",
        name: "Gabriel Greenberg",
        profession: "CEO",
        content: `We  have worked in close cooperation with G2i within last two years. We developed number of powerful projects for them using PHP, Node.js, Angular.js and React.js`,
        phone: "+1 215 378-5660",
        email: `gabriel@g2idesign.com`,
      },
      {
        id: 3,
        companyName:"XciteDigital LTD",
        name: "Rob Walker",
        profession: `CEO`,
        content: `We worked on many  Wordpress based sites for XciteDigial, various HTML templates and many landing pages design.`,
        address:'90 Long Acre, Covent Garden,London, WC2E 9RZ',
        phone: "0207 183 4049",
        email: `rob@xcitedigital.com`,
      },
      {
        id: 4,
        companyName:"Log(n)",
        name: "Jinal Jhaveri",
        profession: "CEO",
        content:
          `CEO and Customer of Rocketship Education (<a href="https://www.rocketshipschools.org/" target="_blank">student management system</a>).<br/>
          Jinal also uses our customized version of <a href="https://time.webdevs.com/index/login" target="_blank">time tracker</a> in order to improve the communication with customer.
          `,
        linkSite: `<a href="https://www.logn.co/" target="_blank">logn.co</a>`,
        address:'565 Commercial St. Suite 200 San Francisco, CA',
        email: `jinal@lognllc.com`,
        phone:"1- 415- 500-2558"
      },
      {
        id: 5,
        companyName:"Sentient",
        name: "Rohan Tucker",
        profession: "General Manager",
        content: `VP, Technology and Customer of a dedicated team working on web projects`,
        linkSite: `<a href="https://besentient.com " target="_blank">besentient.com</a>`,
        address:'One High Street Court, Suite 301 Morristown, NJ 07960',
        email: `rtucker@besentient.com `,
      },
      {
        id: 6,
        companyName:"Maestro Learning",
        name: "Peter Dublin",
        profession:
          "CEO",
        content: `Ed.D., President  and customer of Spelling Grades iOS and Android app ( <a href=" https://itunes.apple.com/us/app/spelling-grades-1-5/id469915255?mt=8" target="_blank">learning game for kids</a> ) and a number of other <a href="https://www.flinklearning.com/apps/" target="_blank">apps</a>.`,
        linkSite: `<a href="https://www.flinklearning.com/" target="_blank">www.flinklearning.com</a>`,
        address:'24 Chilton Street Cambridge, MA 02138',
        phone: "1-617-354-7734",
        email: `peter@maestrolearning.com `,
      },
      {
        id: 7,
        companyName:"Intelligent Wine iOS App",
        name: "Laura Sanchez",
        profession: "CEO and Product Owner",
        content: `App: <a href="https://youtu.be/ou8rL8kDe28" target="_blank">https://youtu.be/ou8rL8kDe28</a>`,
        address:'P.O. Box 21 Carpinteria, Ca 93014',
        email: `laura_sanchez10@hotmail.com`,
        phone:"1 805 455 2905"
      },
    ],
    magentoMenu: [
          {
              path: 'magento',
              hash: '#mg_about',
              name: 'About',
          },
          {
              path: 'magento',
              hash: '#mg_why',
              name: 'Why Magento',
          },
          {
              path: 'magento',
              hash: '#mg_services',
              name: 'Services',
              children: [
                  {
                      path: '/magento-tuning-optimization',
                      name: 'Magento performance tuning and optimization',
                  },
                  {
                      path: '/magento-setup-tuning',
                      name: 'Magento websites setup and tuning',
                  },
                  {
                      path: '/magento-support-security',
                      name: 'Magento support and security patching',
                  },
                  {
                      path: '/magento-security-services',
                      name: 'Express security audit',
                  },
                  {
                      path: '/magento-custom-development',
                      name: 'Custom development for magento',
                  },
                  {
                      path: '/magento-modules-customization',
                      name: '3rd party modules customization',
                  },
                  {
                      path: '/magento-services-integration',
                      name: '3rd party services integration',
                  },
                  {
                      path: '/magento-migration',
                      name: 'Migration to magento from different ecommerce platforms',
                  },
                  {
                      path: '/magento-version-switching',
                      name: 'Switching from magento 1.X to 2.X',
                  }
              ]
          },
          {
              path: 'magento',
              hash: '#mreferences',
              name: 'References',
          },
          {
              path: 'magento',
              hash: '#mg_projects',
              name: 'Projects',
          },
          {
              path: 'magento',
              hash: '#mg_prices',
              name: 'Prices',
          }
  ]
  },
});
